<template>
  <div class="reports-container">
  <PageHeader title="گزارش ها" infoTitle="راهنمای گزارش‌ها" :infoLearnUrl="infoLearnUrl">
    <template #info>
      <p style="line-height:1.9; white-space:pre-line;">
        در این قسمت ابتدا بر روی تب گزارش مد نظر کلیک نموده سپس با پر کردن هر کدام از کادرها و زدن دکمه (تولید گزارش) سیستم گزارش مد نظر را برای شما آماده میکند. برای دریافت خروجی از گزارش میتوانید بر روی دکمه (خروجی اکسل) کلیک نمایید.
        جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
      </p>
    </template>
  </PageHeader>
    <!-- تب‌های گزارش ها -->
    <div class="reports-tabs-container">
      <div class="tabs-carousel-wrapper">
        <button 
          class="carousel-nav-btn carousel-prev" 
          @click="scrollTabs('left')"
        >
          <img src="/img/back.svg" alt="back" class="carousel-icon" />
        </button>
        
        <div class="reports-tabs" ref="tabsContainer">
          <button 
            @click="activeTab = 'patient-payments'" 
            :class="['tab-button', { active: activeTab === 'patient-payments' }]"
          >
            پرداختی بیماران
          </button>
          <button 
            @click="activeTab = 'unsettled-bills'" 
            :class="['tab-button', { active: activeTab === 'unsettled-bills' }]"
          >
            قبض های تسویه نشده
          </button>
          <button 
            @click="activeTab = 'bills-services'" 
            :class="['tab-button', { active: activeTab === 'bills-services' }]"
          >
            قبض ها و خدمات
          </button>
          <button 
            @click="activeTab = 'inventory'" 
            :class="['tab-button', { active: activeTab === 'inventory' }]"
          >
            موجودی کالا
          </button>
          <button 
            @click="activeTab = 'appointments-list'" 
            :class="['tab-button', { active: activeTab === 'appointments-list' }]"
          >
            لیست نوبت ها
          </button>
          <button 
            @click="activeTab = 'doctors-operators-percentage'" 
            :class="['tab-button', { active: activeTab === 'doctors-operators-percentage' }]"
          >
            درصد پزشکان/اپراتورها
          </button>
          <button 
            @click="activeTab = 'sms-report'" 
            :class="['tab-button', { active: activeTab === 'sms-report' }]"
          >
            ارسال پیامک
          </button>
        </div>
        
        <button 
          class="carousel-nav-btn carousel-next" 
          @click="scrollTabs('right')"
        >
          <img src="/img/next.svg" alt="next" class="carousel-icon" />
        </button>
      </div>
    </div>

    <!-- محتوای تب‌ها -->
    <div class="tab-content">
      <!-- تب گزارش پرداختی بیماران -->
      <div v-if="activeTab === 'patient-payments'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <!-- تاریخ‌ها - همیشه نمایش داده می‌شوند -->
              <div class="filter-group">
                <label>از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="filters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="filters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- دکمه بیشتر برای موبایل -->
              <div class="mobile-more-filters">
                <button 
                  @click="showMoreFilters = !showMoreFilters" 
                  class="more-filters-btn"
                >
                  <span>بیشتر</span>
                  <span class="arrow-icon" :class="{ 'rotated': showMoreFilters }">▼</span>
                </button>
              </div>
              
              <!-- فیلترهای اضافی - در دسکتاپ همیشه نمایش، در موبایل فقط وقتی دکمه بیشتر زده شود -->
              <div class="additional-filters" :class="{ 'show': showMoreFilters }">
              <!-- نام پزشک -->
              <div class="filter-group">
                <label>نام پزشک:</label>
                <select v-model="filters.doctorName" class="form-select">
                  <option value="">همه پزشکان</option>
                  <option v-for="doctor in doctorsList" :key="doctor.id" :value="doctor.name">
                    {{ doctor.name }}
                  </option>
                </select>
              </div>
              
              <!-- نام بیمار -->
              <div class="filter-group">
                <label>نام بیمار:</label>
                <input 
                  v-model="filters.patientName" 
                  type="text" 
                  placeholder="نام بیمار..."
                  class="form-input"
                />
              </div>
              
              <!-- شماره تلفن -->
              <div class="filter-group">
                <label>شماره تلفن:</label>
                <input 
                  v-model="filters.phoneNumber" 
                  type="text" 
                  placeholder="شماره تلفن..."
                  class="form-input"
                />
              </div>
              
              <!-- تلفن همراه -->
              <div class="filter-group">
                <label>تلفن همراه:</label>
                <input 
                  v-model="filters.mobileNumber" 
                  type="text" 
                  placeholder="تلفن همراه..."
                  class="form-input"
                />
              </div>
              
              <!-- نوع پرداخت -->
              <div class="filter-group">
                <label>نوع پرداخت:</label>
                <select v-model="filters.paymentType" class="form-select">
                  <option value="">همه انواع</option>
                  <option value="نقدی">نقدی</option>
                  <option value="کارت">کارت</option>
                  <option value="چک">چک</option>
                  <option value="حواله">حواله</option>
                </select>
              </div>
              
              <!-- شماره پرونده -->
              <div class="filter-group">
                <label>شماره پرونده:</label>
                <input 
                  v-model="filters.fileNumber" 
                  type="text" 
                  placeholder="شماره پرونده..."
                  class="form-input"
                />
              </div>
              
              <!-- شماره مدرک -->
              <div class="filter-group">
                <label>شماره مدرک:</label>
                <input 
                  v-model="filters.documentNumber" 
                  type="text" 
                  placeholder="شماره مدرک..."
                  class="form-input"
                />
              </div>
              
              <!-- نام معرف -->
              <div class="filter-group">
                <label>نام معرف:</label>
                <input 
                  v-model="filters.referrerName" 
                  type="text" 
                  placeholder="نام معرف..."
                  class="form-input"
                />
              </div>
              
              <!-- بابت -->
              <div class="filter-group">
                <label>بابت:</label>
                <input 
                  v-model="filters.purpose" 
                  type="text" 
                  placeholder="بابت..."
                  class="form-input"
                />
              </div>
              
              <!-- توضیحات -->
              <div class="filter-group">
                <label>توضیحات:</label>
                <input 
                  v-model="filters.description" 
                  type="text" 
                  placeholder="توضیحات..."
                  class="form-input"
                />
              </div>
              
              <!-- واسطه -->
              <div class="filter-group">
                <label>واسطه:</label>
                <input 
                  v-model="filters.intermediary" 
                  type="text" 
                  placeholder="واسطه..."
                  class="form-input"
                />
              </div>
              
              <!-- چک باکس‌های نمایش -->
              <div class="filter-group checkbox-group">
                <div class="checkbox-container">
                  <label class="checkbox-label white">
                    <input 
                      type="checkbox" 
                      v-model="filters.showValidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل نشده</span>
                  </label>
                  <label class="checkbox-label pink">
                    <input 
                      type="checkbox" 
                      v-model="filters.showInvalidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل شده</span>
                  </label>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearPatientPaymentsFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generatePatientPaymentsReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printReport" />
              </div>
              
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ reportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ reportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ reportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="report-content">
          <!-- Desktop Table -->
          <div class="desktop-table">
            <BaseTable
              :items="paginatedPatientPayments"
              :empty-colspan="19"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>شماره قبض</th>
                  <th>تاریخ قبض</th>
                  <th>نام بیمار</th>
                  <th>کد خدمات</th>
                  <th>نام خدمات</th>
                  <th>شماره پرونده</th>
                  <th>نام پزشک</th>
                  <th>تلفن بیمار</th>
                  <th>تلفن همراه</th>
                  <th>نام واسطه</th>
                  <th>مبلغ سهم بیمه</th>
                  <th>مبلغ سهم بیمار</th>
                  <th>جمع کل</th>
                  <th>توضیحات</th>
                  <th>کاربر ثبت کننده</th>
                  <th>تاریخ ثبت</th>
                  <th>زمان ثبت</th>
                  <th>درصد جمع کل</th>
                </tr>
              </template>
              <template #row="{ item: payment, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ payment.invoiceNumber || '-' }}</td>
                  <td>{{ payment.invoiceDate || payment.paymentDate || '-' }}</td>
                  <td>{{ payment.patientName }}</td>
                  <td>{{ payment.serviceCode || '-' }}</td>
                  <td>{{ payment.serviceName || payment.purpose || '-' }}</td>
                  <td>{{ payment.fileNumber }}</td>
                  <td>{{ payment.doctorName }}</td>
                  <td>{{ payment.phoneNumber || '-' }}</td>
                  <td>{{ payment.mobileNumber }}</td>
                  <td>{{ payment.intermediary || payment.referrerName || '-' }}</td>
                  <td>{{ formatNumber(payment.insuranceAmount || 0) }} ریال</td>
                  <td>{{ formatNumber(payment.patientAmount || payment.amount || 0) }} ریال</td>
                  <td>{{ formatNumber(payment.totalAmount || payment.amount || 0) }} ریال</td>
                  <td>{{ payment.description || '-' }}</td>
                  <td>{{ payment.createdBy || 'سیستم' }}</td>
                  <td>{{ payment.createdDate || moment().format('jYYYY/jMM/jDD') }}</td>
                  <td>{{ payment.createdTime || moment().format('HH:mm:ss') }}</td>
                  <td>{{ payment.percentage || '100%' }}</td>
              </template>
            </BaseTable>
          </div>

          <!-- Mobile Table -->
          <div class="mobile-table">
            <div v-for="(payment, index) in paginatedPatientPayments" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">تاریخ:</span>
                    <span class="mobile-value">{{ payment.invoiceDate || payment.paymentDate || '-' }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام بیمار:</span>
                    <span class="mobile-value">{{ payment.patientName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">مبلغ پرداختی:</span>
                    <span class="mobile-value">{{ formatNumber(payment.totalAmount || payment.amount || 0) }} ریال</span>
                  </div>
                </div>
                <button @click="showPaymentDetails(payment)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Pagination Controls -->
          <div class="pagination-container" v-if="totalPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentPage }} از {{ totalPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousPage" 
                  :disabled="currentPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextPage" 
                  :disabled="currentPage === totalPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentPage - 1) * itemsPerPage) + 1 }} تا {{ Math.min(currentPage * itemsPerPage, filteredPatientPayments.length) }} از {{ filteredPatientPayments.length }} رکورد</span>
              </div>
            </div>
          </div>

          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد پرداخت‌ها:</span>
              <span>{{ filteredPatientPayments.length }}</span>
            </div>
            <div class="summary-item">
              <span>درصد پزشک:</span>
              <span>{{ doctorPercentage }}%</span>
            </div>
            <div class="summary-item">
              <span>جمع سهم بیمار:</span>
              <span>{{ formatNumber(totalPatientAmount) }} ریال</span>
            </div>
            <div class="summary-item">
              <span>مجموع مبلغ:</span>
              <span>{{ formatNumber(totalFilteredPatientPayments) }} ریال</span>
            </div>
          </div>
        </div>

        <!-- Payment Details Modal -->
  <div v-if="showPaymentModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <ModalHeader>
              <template #default>
                <h3>جزئیات پرداخت</h3>
              </template>
              <template #actions>
                <button @click="closePaymentModal" class="modal-close-btn">×</button>
              </template>
            </ModalHeader>
            <div class="modal-body" v-if="selectedPaymentDetails">
              <div class="payment-details">
                <div class="detail-row">
                  <span class="detail-label">شماره قبض:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.invoiceNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ قبض:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.invoiceDate || selectedPaymentDetails.paymentDate || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام بیمار:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.patientName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کد خدمات:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.serviceCode || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام خدمات:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.serviceName || selectedPaymentDetails.purpose || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">شماره پرونده:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.fileNumber }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام پزشک:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.doctorName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن بیمار:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.phoneNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن همراه:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.mobileNumber }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام واسطه:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.intermediary || selectedPaymentDetails.referrerName || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مبلغ سهم بیمه:</span>
                  <span class="detail-value">{{ formatNumber(selectedPaymentDetails.insuranceAmount || 0) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مبلغ سهم بیمار:</span>
                  <span class="detail-value">{{ formatNumber(selectedPaymentDetails.patientAmount || selectedPaymentDetails.amount || 0) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">جمع کل:</span>
                  <span class="detail-value">{{ formatNumber(selectedPaymentDetails.totalAmount || selectedPaymentDetails.amount || 0) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">توضیحات:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.description || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کاربر ثبت کننده:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.createdBy || 'سیستم' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ ثبت:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.createdDate || moment().format('jYYYY/jMM/jDD') }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">زمان ثبت:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.createdTime || moment().format('HH:mm:ss') }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">درصد جمع کل:</span>
                  <span class="detail-value">{{ selectedPaymentDetails.percentage || '100%' }}</span>
                </div>
              </div>
              
              <!-- Scroll Indicator -->
              <div class="scroll-indicator">
                <div class="scroll-arrow">
                  <span class="arrow-down">↓</span>
                </div>
                <span class="scroll-text">اسکرول کنید</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- تب گزارش قبض های تسویه نشده -->
      <div v-if="activeTab === 'unsettled-bills'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <!-- از تاریخ ثبت -->
              <div class="filter-group">
                <label>از تاریخ ثبت:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="unsettledFilters.fromRegistrationDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- تا تاریخ ثبت -->
              <div class="filter-group">
                <label>تا تاریخ ثبت:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="unsettledFilters.toRegistrationDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- دکمه بیشتر برای موبایل -->
              <div class="mobile-more-filters">
                <button 
                  @click="showMoreUnsettledFilters = !showMoreUnsettledFilters" 
                  class="more-filters-btn"
                >
                  <span>بیشتر</span>
                  <span class="arrow-icon" :class="{ 'rotated': showMoreUnsettledFilters }">▼</span>
                </button>
              </div>
              
              <!-- فیلترهای اضافی - در دسکتاپ همیشه نمایش، در موبایل فقط وقتی دکمه بیشتر زده شود -->
              <div class="additional-filters" :class="{ 'show': showMoreUnsettledFilters }">
              <!-- شماره قبض از -->
              <div class="filter-group">
                <label>از شماره قبض:</label>
                <input 
                  v-model="unsettledFilters.fromBillNumber" 
                  type="text" 
                  placeholder="شماره قبض..."
                  class="form-input"
                />
              </div>
              
              <!-- شماره قبض تا -->
              <div class="filter-group">
                <label>تا شماره قبض:</label>
                <input 
                  v-model="unsettledFilters.toBillNumber" 
                  type="text" 
                  placeholder="شماره قبض..."
                  class="form-input"
                />
              </div>
              
              <!-- نام پزشک -->
              <div class="filter-group">
                <label>نام پزشک:</label>
                <select v-model="unsettledFilters.doctorName" class="form-select">
                  <option value="">همه پزشکان</option>
                  <option v-for="doctor in doctorsList" :key="doctor.id" :value="doctor.name">
                    {{ doctor.name }}
                  </option>
                </select>
              </div>
              
              <!-- نام بیمار -->
              <div class="filter-group">
                <label>نام بیمار:</label>
                <input 
                  v-model="unsettledFilters.patientName" 
                  type="text" 
                  placeholder="نام بیمار..."
                  class="form-input"
                />
              </div>
              
              <!-- شماره پرونده -->
              <div class="filter-group">
                <label>شماره پرونده:</label>
                <input 
                  v-model="unsettledFilters.fileNumber" 
                  type="text" 
                  placeholder="شماره پرونده..."
                  class="form-input"
                />
              </div>
              
              <!-- تلفن بیمار -->
              <div class="filter-group">
                <label>تلفن بیمار:</label>
                <input 
                  v-model="unsettledFilters.phoneNumber" 
                  type="text" 
                  placeholder="تلفن بیمار..."
                  class="form-input"
                />
              </div>
              
              <!-- تلفن همراه -->
              <div class="filter-group">
                <label>تلفن همراه:</label>
                <input 
                  v-model="unsettledFilters.mobileNumber" 
                  type="text" 
                  placeholder="تلفن همراه..."
                  class="form-input"
                />
              </div>
              
              <!-- واسطه -->
              <div class="filter-group">
                <label>واسطه:</label>
                <input 
                  v-model="unsettledFilters.intermediary" 
                  type="text" 
                  placeholder="واسطه..."
                  class="form-input"
                />
              </div>
              
              <!-- کاربر ثبت کننده -->
              <div class="filter-group">
                <label>کاربر ثبت کننده:</label>
                <input 
                  v-model="unsettledFilters.createdBy" 
                  type="text" 
                  placeholder="کاربر ثبت کننده..."
                  class="form-input"
                />
              </div>
              
              <!-- چک باکس‌های نمایش -->
              <div class="filter-group checkbox-group">
                <div class="checkbox-container">
                  <label class="checkbox-label white">
                    <input 
                      type="checkbox" 
                      v-model="unsettledFilters.showValidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل نشده</span>
                  </label>
                  <label class="checkbox-label pink">
                    <input 
                      type="checkbox" 
                      v-model="unsettledFilters.showInvalidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل شده</span>
                  </label>
                </div>
              </div>
              </div>
            </div>
            
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearUnsettledBillsFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generateUnsettledBillsReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportUnsettledBillsToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printUnsettledBillsReport" />
              </div>
              
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ unsettledReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ unsettledReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ unsettledReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="report-content">
          <!-- Desktop Table -->
          <div class="desktop-table">
            <BaseTable
              :items="paginatedUnsettledBills"
              :empty-colspan="16"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>شماره قبض</th>
                  <th>تاریخ قبض</th>
                  <th>نام بیمار</th>
                  <th>مانده قبض</th>
                  <th>جمع قابل پرداخت</th>
                  <th>شماره پرونده</th>
                  <th>تلفن بیمار</th>
                  <th>تلفن همراه</th>
                  <th>نام واسطه</th>
                  <th>مبلغ سهم بیمه</th>
                  <th>مبلغ سهم بیمار</th>
                  <th>جمع کل</th>
                  <th>کاربر ثبت کننده</th>
                  <th>تاریخ ثبت</th>
                  <th>زمان ثبت</th>
                </tr>
              </template>
              <template #row="{ item: bill, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ bill.invoiceNumber }}</td>
                  <td>{{ bill.invoiceDate || bill.issueDate }}</td>
                  <td>{{ bill.patientName }}</td>
                  <td>{{ formatNumber(bill.remainingAmount || bill.amount) }} ریال</td>
                  <td>{{ formatNumber(bill.payableAmount || bill.amount) }} ریال</td>
                  <td>{{ bill.fileNumber }}</td>
                  <td>{{ bill.phoneNumber }}</td>
                  <td>{{ bill.mobileNumber }}</td>
                  <td>{{ bill.intermediary }}</td>
                  <td>{{ formatNumber(bill.insuranceAmount || 0) }} ریال</td>
                  <td>{{ formatNumber(bill.patientAmount || bill.amount) }} ریال</td>
                  <td>{{ formatNumber(bill.totalAmount || bill.amount) }} ریال</td>
                  <td>{{ bill.createdBy }}</td>
                  <td>{{ bill.createdDate }}</td>
                  <td>{{ bill.createdTime }}</td>
              </template>
            </BaseTable>
          </div>

          <!-- Mobile Table -->
          <div class="mobile-table">
            <div v-for="(bill, index) in paginatedUnsettledBills" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام بیمار:</span>
                    <span class="mobile-value">{{ bill.patientName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">تاریخ قبض:</span>
                    <span class="mobile-value">{{ bill.invoiceDate || bill.issueDate }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">مانده قبض:</span>
                    <span class="mobile-value">{{ formatNumber(bill.remainingAmount || bill.amount) }} ریال</span>
                  </div>
                </div>
                <button @click="showUnsettledBillDetails(bill)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for Unsettled Bills -->
          <div class="pagination-container" v-if="totalUnsettledPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentUnsettledPage }} از {{ totalUnsettledPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousUnsettledPage" 
                  :disabled="currentUnsettledPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextUnsettledPage" 
                  :disabled="currentUnsettledPage === totalUnsettledPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentUnsettledPage - 1) * unsettledItemsPerPage) + 1 }} تا {{ Math.min(currentUnsettledPage * unsettledItemsPerPage, filteredUnsettledBills.length) }} از {{ filteredUnsettledBills.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد قبض‌های تسویه نشده:</span>
              <span>{{ filteredUnsettledBills.length }}</span>
            </div>
            <div class="summary-item">
              <span>جمع مانده ها:</span>
              <span>{{ formatNumber(totalRemainingAmount) }} ریال</span>
            </div>
            <div class="summary-item">
              <span>جمع کل قابل پرداخت:</span>
              <span>{{ formatNumber(totalPayableAmount) }} ریال</span>
            </div>
          </div>
        </div>

        <!-- Unsettled Bill Details Modal -->
  <div v-if="showUnsettledBillModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <ModalHeader>
              <template #default>
                <h3>جزئیات قبض تسویه نشده</h3>
              </template>
              <template #actions>
                <button @click="closeUnsettledBillModal" class="modal-close-btn">×</button>
              </template>
            </ModalHeader>
            <div class="modal-body" v-if="selectedUnsettledBillDetails">
              <div class="payment-details">
                <div class="detail-row">
                  <span class="detail-label">شماره قبض:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.invoiceNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ قبض:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.invoiceDate || selectedUnsettledBillDetails.issueDate || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام بیمار:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.patientName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مانده قبض:</span>
                  <span class="detail-value">{{ formatNumber(selectedUnsettledBillDetails.remainingAmount || selectedUnsettledBillDetails.amount) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">جمع قابل پرداخت:</span>
                  <span class="detail-value">{{ formatNumber(selectedUnsettledBillDetails.payableAmount || selectedUnsettledBillDetails.amount) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">شماره پرونده:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.fileNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن بیمار:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.phoneNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن همراه:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.mobileNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام واسطه:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.intermediary || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مبلغ سهم بیمه:</span>
                  <span class="detail-value">{{ formatNumber(selectedUnsettledBillDetails.insuranceAmount || 0) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مبلغ سهم بیمار:</span>
                  <span class="detail-value">{{ formatNumber(selectedUnsettledBillDetails.patientAmount || selectedUnsettledBillDetails.amount) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">جمع کل:</span>
                  <span class="detail-value">{{ formatNumber(selectedUnsettledBillDetails.totalAmount || selectedUnsettledBillDetails.amount) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کاربر ثبت کننده:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.createdBy || 'سیستم' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ ثبت:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.createdDate || moment().format('jYYYY/jMM/jDD') }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">زمان ثبت:</span>
                  <span class="detail-value">{{ selectedUnsettledBillDetails.createdTime || moment().format('HH:mm:ss') }}</span>
                </div>
              </div>
              
              <!-- Scroll Indicator -->
              <div class="scroll-indicator">
                <div class="scroll-arrow">
                  <span class="arrow-down">↓</span>
                </div>
                <span class="scroll-text">اسکرول کنید</span>
              </div>
            </div>
          </div>
        </div>
        </div>

        <!-- Inventory Details Modal -->
  <div v-if="showInventoryModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <ModalHeader>
              <template #default>
                <h3>جزئیات کالا</h3>
              </template>
              <template #actions>
                <button @click="closeInventoryModal" class="modal-close-btn">×</button>
              </template>
            </ModalHeader>
            <div class="modal-body" v-if="selectedInventoryDetails">
              <div class="payment-details">
                <div class="detail-row">
                  <span class="detail-label">نام کالا:</span>
                  <span class="detail-value">{{ selectedInventoryDetails.name }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کد کالا:</span>
                  <span class="detail-value">{{ selectedInventoryDetails.code }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">موجودی فعلی:</span>
                  <span class="detail-value">{{ selectedInventoryDetails.currentStock }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">حداقل موجودی:</span>
                  <span class="detail-value">{{ selectedInventoryDetails.minStock }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">وضعیت:</span>
                  <span class="detail-value">
                    <span :class="['status-badge', selectedInventoryDetails.status]">
                      {{ selectedInventoryDetails.status === 'low' ? 'کم' : selectedInventoryDetails.status === 'out' ? 'تمام' : 'کافی' }}
                    </span>
                  </span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">قیمت واحد:</span>
                  <span class="detail-value">{{ formatNumber(selectedInventoryDetails.unitPrice) }} ریال</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- تب گزارش از قبض ها و خدمات -->
      <div v-if="activeTab === 'bills-services'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <!-- از تاریخ -->
              <div class="filter-group">
                <label>از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="billsServicesFilters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- تا تاریخ -->
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="billsServicesFilters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- دکمه بیشتر برای موبایل -->
              <div class="mobile-more-filters">
                <button 
                  @click="showMoreBillsServicesFilters = !showMoreBillsServicesFilters" 
                  class="more-filters-btn"
                >
                  <span>بیشتر</span>
                  <span class="arrow-icon" :class="{ 'rotated': showMoreBillsServicesFilters }">▼</span>
                </button>
              </div>
              
              <!-- فیلترهای اضافی - در دسکتاپ همیشه نمایش، در موبایل فقط وقتی دکمه بیشتر زده شود -->
              <div class="additional-filters" :class="{ 'show': showMoreBillsServicesFilters }">
              <!-- از شماره قبض -->
              <div class="filter-group">
                <label>از شماره قبض:</label>
                <input 
                  v-model="billsServicesFilters.fromBillNumber" 
                  type="text" 
                  placeholder="شماره قبض..."
                  class="form-input"
                />
              </div>
              
              <!-- تا شماره قبض -->
              <div class="filter-group">
                <label>تا شماره قبض:</label>
                <input 
                  v-model="billsServicesFilters.toBillNumber" 
                  type="text" 
                  placeholder="شماره قبض..."
                  class="form-input"
                />
              </div>
              
              <!-- از تاریخ ثبت -->
              <div class="filter-group">
                <label>از تاریخ ثبت:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="billsServicesFilters.fromRegistrationDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- تا تاریخ ثبت -->
              <div class="filter-group">
                <label>تا تاریخ ثبت:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="billsServicesFilters.toRegistrationDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- نام پزشک -->
              <div class="filter-group">
                <label>نام پزشک:</label>
                <select v-model="billsServicesFilters.doctorName" class="form-select">
                  <option value="">همه پزشکان</option>
                  <option v-for="doctor in doctorsList" :key="doctor.id" :value="doctor.name">
                    {{ doctor.name }}
                  </option>
                </select>
              </div>
              
              <!-- نام بیمار -->
              <div class="filter-group">
                <label>نام بیمار:</label>
                <input 
                  v-model="billsServicesFilters.patientName" 
                  type="text" 
                  placeholder="نام بیمار..."
                  class="form-input"
                />
              </div>
              
              <!-- شماره پرونده -->
              <div class="filter-group">
                <label>شماره پرونده:</label>
                <input 
                  v-model="billsServicesFilters.fileNumber" 
                  type="text" 
                  placeholder="شماره پرونده..."
                  class="form-input"
                />
              </div>
              
              <!-- تلفن بیمار -->
              <div class="filter-group">
                <label>تلفن بیمار:</label>
                <input 
                  v-model="billsServicesFilters.phoneNumber" 
                  type="text" 
                  placeholder="تلفن بیمار..."
                  class="form-input"
                />
              </div>
              
              <!-- تلفن همراه -->
              <div class="filter-group">
                <label>تلفن همراه:</label>
                <input 
                  v-model="billsServicesFilters.mobileNumber" 
                  type="text" 
                  placeholder="تلفن همراه..."
                  class="form-input"
                />
              </div>
              
              <!-- کاربر ثبت کننده -->
              <div class="filter-group">
                <label>کاربر ثبت کننده:</label>
                <input 
                  v-model="billsServicesFilters.createdBy" 
                  type="text" 
                  placeholder="کاربر ثبت کننده..."
                  class="form-input"
                />
              </div>
              
              <!-- توضیحات -->
              <div class="filter-group">
                <label>توضیحات:</label>
                <input 
                  v-model="billsServicesFilters.description" 
                  type="text" 
                  placeholder="توضیحات..."
                  class="form-input"
                />
              </div>
              
              <!-- نام خدمات -->
              <div class="filter-group">
                <label>نام خدمات:</label>
                <input 
                  v-model="billsServicesFilters.serviceName" 
                  type="text" 
                  placeholder="نام خدمات..."
                  class="form-input"
                />
              </div>
              
              <!-- کد خدمات -->
              <div class="filter-group">
                <label>کد خدمات:</label>
                <input 
                  v-model="billsServicesFilters.serviceCode" 
                  type="text" 
                  placeholder="کد خدمات..."
                  class="form-input"
                />
              </div>
              
              <!-- واسطه -->
              <div class="filter-group">
                <label>واسطه:</label>
                <input 
                  v-model="billsServicesFilters.intermediary" 
                  type="text" 
                  placeholder="واسطه..."
                  class="form-input"
                />
              </div>
              
              <!-- چک باکس‌های نمایش -->
              <div class="filter-group checkbox-group">
                <div class="checkbox-container">
                  <label class="checkbox-label white">
                    <input 
                      type="checkbox" 
                      v-model="billsServicesFilters.showValidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل نشده</span>
                  </label>
                  <label class="checkbox-label pink">
                    <input 
                      type="checkbox" 
                      v-model="billsServicesFilters.showInvalidBills"
                      class="checkbox-input"
                    />
                    <span class="checkbox-text">نمایش قبض های باطل شده</span>
                  </label>
                </div>
              </div>
              </div>
            </div>
            
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearBillsServicesFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generateBillsServicesReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportBillsServicesToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printBillsServicesReport" />
              </div>
              
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ billsServicesReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ billsServicesReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ billsServicesReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="report-content">
          <div class="desktop-table">
            <BaseTable
              :items="paginatedBillsServices"
              :empty-colspan="18"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>شماره قبض</th>
                  <th>تاریخ قبض</th>
                  <th>نام بیمار</th>
                  <th>نام پزشک</th>
                  <th>شماره پرونده</th>
                  <th>تلفن بیمار</th>
                  <th>تلفن همراه</th>
                  <th>کاربر ثبت کننده</th>
                  <th>توضیحات</th>
                  <th>نام خدمات</th>
                  <th>کد خدمات</th>
                  <th>واسطه</th>
                  <th>مبلغ واحد</th>
                  <th>تعداد</th>
                  <th>جمع کل</th>
                  <th>تاریخ ثبت</th>
                  <th>زمان ثبت</th>
                </tr>
              </template>
              <template #row="{ item: service, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ service.invoiceNumber }}</td>
                  <td>{{ service.invoiceDate || service.date }}</td>
                  <td>{{ service.patientName }}</td>
                  <td>{{ service.doctorName }}</td>
                  <td>{{ service.fileNumber }}</td>
                  <td>{{ service.phoneNumber || '-' }}</td>
                  <td>{{ service.mobileNumber || '-' }}</td>
                  <td>{{ service.createdBy || 'سیستم' }}</td>
                  <td>{{ service.description || '-' }}</td>
                  <td>{{ service.serviceName }}</td>
                  <td>{{ service.serviceCode || '-' }}</td>
                  <td>{{ service.intermediary || '-' }}</td>
                  <td>{{ formatNumber(service.unitPrice) }} ریال</td>
                  <td>{{ service.quantity }}</td>
                  <td>{{ formatNumber(service.totalPrice) }} ریال</td>
                  <td>{{ service.createdDate || moment().format('jYYYY/jMM/jDD') }}</td>
                  <td>{{ service.createdTime || moment().format('HH:mm:ss') }}</td>
              </template>
            </BaseTable>
          </div>

          <!-- Mobile Table for Bills and Services -->
          <div class="mobile-table">
            <div v-for="(service, index) in paginatedBillsServices" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام پزشک:</span>
                    <span class="mobile-value">{{ service.doctorName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">تاریخ قبض:</span>
                    <span class="mobile-value">{{ service.invoiceDate || service.date }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام بیمار:</span>
                    <span class="mobile-value">{{ service.patientName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام خدمات:</span>
                    <span class="mobile-value">{{ service.serviceName }}</span>
                  </div>
                </div>
                <button @click="showBillsServicesDetails(service)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for Bills and Services -->
          <div class="pagination-container" v-if="totalBillsServicesPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentBillsServicesPage }} از {{ totalBillsServicesPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousBillsServicesPage" 
                  :disabled="currentBillsServicesPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextBillsServicesPage" 
                  :disabled="currentBillsServicesPage === totalBillsServicesPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentBillsServicesPage - 1) * billsServicesItemsPerPage) + 1 }} تا {{ Math.min(currentBillsServicesPage * billsServicesItemsPerPage, filteredBillsServices.length) }} از {{ filteredBillsServices.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد پرداخت‌ها:</span>
              <span>{{ filteredBillsServices.length }}</span>
            </div>
            <div class="summary-item">
              <span>جمع سهم بیمه:</span>
              <span>{{ formatNumber(totalInsuranceAmount) }} ریال</span>
            </div>
            <div class="summary-item">
              <span>جمع سهم بیمار:</span>
              <span>{{ formatNumber(totalPatientShare) }} ریال</span>
            </div>
            <div class="summary-item">
              <span>درصد:</span>
              <span>{{ insurancePercentage }}%</span>
            </div>
            <div class="summary-item">
              <span>جمع کل:</span>
              <span>{{ formatNumber(totalFilteredBillsServices) }} ریال</span>
            </div>
          </div>
        </div>

        <!-- Bills-Services Details Modal -->
  <div v-if="showBillsServicesModal" class="modal-overlay">
          <div class="modal-content" @click.stop>
            <ModalHeader>
              <template #default>
                <h3>جزئیات قبض و خدمات</h3>
              </template>
              <template #actions>
                <button @click="closeBillsServicesModal" class="modal-close-btn">×</button>
              </template>
            </ModalHeader>
            <div class="modal-body" v-if="selectedBillsServicesDetails">
              <div class="payment-details">
                <div class="detail-row">
                  <span class="detail-label">شماره قبض:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.invoiceNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ قبض:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.invoiceDate || selectedBillsServicesDetails.date || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام بیمار:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.patientName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام پزشک:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.doctorName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">شماره پرونده:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.fileNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن بیمار:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.phoneNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تلفن همراه:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.mobileNumber || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">نام خدمات:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.serviceName }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کد خدمات:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.serviceCode || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">واسطه:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.intermediary || '-' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">مبلغ واحد:</span>
                  <span class="detail-value">{{ formatNumber(selectedBillsServicesDetails.unitPrice) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تعداد:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.quantity }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">جمع کل:</span>
                  <span class="detail-value">{{ formatNumber(selectedBillsServicesDetails.totalPrice) }} ریال</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">کاربر ثبت کننده:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.createdBy || 'سیستم' }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">تاریخ ثبت:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.createdDate || moment().format('jYYYY/jMM/jDD') }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">زمان ثبت:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.createdTime || moment().format('HH:mm:ss') }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">توضیحات:</span>
                  <span class="detail-value">{{ selectedBillsServicesDetails.description || '-' }}</span>
                </div>
              </div>
              
              <!-- Scroll Indicator -->
              <div class="scroll-indicator">
                <div class="scroll-arrow">
                  <span class="arrow-down">↓</span>
                </div>
                <span class="scroll-text">اسکرول کنید</span>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- تب گزارش موجودی کالا -->
      <div v-if="activeTab === 'inventory'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <!-- نمایش گردش کالا از تاریخ -->
              <div class="filter-group">
                <label>نمایش گردش کالا از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="inventoryFilters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- تا تاریخ -->
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="inventoryFilters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              
              <!-- نام کالا -->
              <div class="filter-group">
                <label>نام کالا:</label>
                <input 
                  v-model="inventoryFilters.itemName" 
                  type="text" 
                  placeholder="نام کالا..."
                  class="form-input"
                />
              </div>
            </div>
            
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearInventoryFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generateInventoryReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportInventoryToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printInventoryReport" />
              </div>
              
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ inventoryReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ inventoryReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ inventoryReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="report-content">
          <div class="desktop-table">
            <BaseTable
              :items="paginatedInventory"
              :empty-colspan="7"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>نام کالا</th>
                  <th>کد کالا</th>
                  <th>موجودی فعلی</th>
                  <th>حداقل موجودی</th>
                  <th>وضعیت</th>
                  <th>قیمت واحد</th>
                </tr>
              </template>
              <template #row="{ item, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td>{{ item.currentStock }}</td>
                  <td>{{ item.minStock }}</td>
                  <td>
                    <span :class="['status-badge', item.status]">
                      {{ item.status === 'low' ? 'کم' : item.status === 'out' ? 'تمام' : 'کافی' }}
                    </span>
                  </td>
                  <td>{{ formatNumber(item.unitPrice) }} ریال</td>
              </template>
            </BaseTable>
          </div>

          <!-- Mobile Table for Inventory -->
          <div class="mobile-table">
            <div v-for="(item, index) in paginatedInventory" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام کالا:</span>
                    <span class="mobile-value">{{ item.name }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">موجودی فعلی:</span>
                    <span class="mobile-value">{{ item.currentStock }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">وضعیت:</span>
                    <span class="mobile-value">
                      <span :class="['status-badge', item.status]">
                        {{ item.status === 'low' ? 'کم' : item.status === 'out' ? 'تمام' : 'کافی' }}
                      </span>
                    </span>
                  </div>
                </div>
                <button @click="showInventoryDetails(item)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for Inventory -->
          <div class="pagination-container" v-if="totalInventoryPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentInventoryPage }} از {{ totalInventoryPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousInventoryPage" 
                  :disabled="currentInventoryPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextInventoryPage" 
                  :disabled="currentInventoryPage === totalInventoryPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentInventoryPage - 1) * inventoryItemsPerPage) + 1 }} تا {{ Math.min(currentInventoryPage * inventoryItemsPerPage, filteredInventory.length) }} از {{ filteredInventory.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد کالاها:</span>
              <span>{{ filteredInventory.length }}</span>
            </div>
            <div class="summary-item">
              <span>کالاهای کم موجود:</span>
              <span>{{ lowStockItems }}</span>
            </div>
            <div class="summary-item">
              <span>کالاهای تمام شده:</span>
              <span>{{ outOfStockItems }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- تب گزارش لیست نوبت ها -->
      <div v-if="activeTab === 'appointments-list'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <div class="filter-group">
                <label>از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="appointmentsFilters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="appointmentsFilters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>پزشک:</label>
                <select v-model="appointmentsFilters.doctorName" class="form-select">
                  <option value="">همه</option>
                  <option v-for="doctor in doctorsList" :key="doctor.id" :value="doctor.name">{{ doctor.name }}</option>
                </select>
              </div>
              <div class="filter-group">
                <label>اپراتور:</label>
                <input v-model="appointmentsFilters.operatorName" type="text" placeholder="نام اپراتور..." class="form-input" />
              </div>
              <div class="filter-group">
                <label>نام بیمار:</label>
                <input v-model="appointmentsFilters.patientName" type="text" placeholder="نام بیمار..." class="form-input" />
              </div>
              <div class="filter-group">
                <label>وضعیت:</label>
                <select v-model="appointmentsFilters.status" class="form-select">
                  <option value="">همه وضعیت‌ها</option>
                  <option value="scheduled">رزرو شده</option>
                  <option value="done">انجام شده</option>
                  <option value="cancelled">لغو شده</option>
                  <option value="no_show">عدم حضور</option>
                </select>
              </div>
            </div>
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearAppointmentsFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generateAppointmentsReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportAppointmentsToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printAppointmentsReport" />
              </div>
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ appointmentsReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ appointmentsReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ appointmentsReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-content">
          <!-- Desktop Table -->
          <div class="desktop-table">
            <BaseTable
              :items="paginatedAppointments"
              :empty-colspan="9"
              :row-key="(_, index) => index"
            >
              <template #head>
                  <tr>
                    <th>ردیف</th>
                    <th>تاریخ</th>
                    <th>ساعت</th>
                    <th>بیمار</th>
                    <th>پزشک</th>
                    <th>اپراتور</th>
                    <th>تلفن همراه</th>
                    <th>وضعیت</th>
                    <th>توضیحات</th>
                  </tr>
              </template>
              <template #row="{ item, index }">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.patientName }}</td>
                    <td>{{ item.doctorName }}</td>
                    <td>{{ item.operatorName || '-' }}</td>
                    <td>{{ item.mobileNumber || '-' }}</td>
                    <td>{{ item.statusText }}</td>
                    <td>{{ item.description || '-' }}</td>
              </template>
            </BaseTable>
          </div>

          <!-- Mobile Table -->
          <div class="mobile-table">
            <div v-for="(appointment, index) in paginatedAppointments" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">تاریخ:</span>
                    <span class="mobile-value">{{ appointment.date }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام بیمار:</span>
                    <span class="mobile-value">{{ appointment.patientName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام پزشک:</span>
                    <span class="mobile-value">{{ appointment.doctorName }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">شماره همراه:</span>
                    <span class="mobile-value">{{ appointment.mobileNumber || '-' }}</span>
                  </div>
                </div>
                <button @click="showAppointmentDetails(appointment)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for Appointments -->
          <div class="pagination-container" v-if="totalAppointmentsPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentAppointmentsPage }} از {{ totalAppointmentsPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousAppointmentsPage" 
                  :disabled="currentAppointmentsPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextAppointmentsPage" 
                  :disabled="currentAppointmentsPage === totalAppointmentsPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentAppointmentsPage - 1) * appointmentsItemsPerPage) + 1 }} تا {{ Math.min(currentAppointmentsPage * appointmentsItemsPerPage, filteredAppointments.length) }} از {{ filteredAppointments.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد نوبت‌ها:</span>
              <span>{{ filteredAppointments.length }}</span>
            </div>
            <div class="summary-item">
              <span>نوبت‌های آتی:</span>
              <span>{{ upcomingAppointments }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- تب گزارش درصد پزشکان/اپراتورها -->
      <div v-if="activeTab === 'doctors-operators-percentage'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <div class="filter-group">
                <label>از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="percentFilters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="percentFilters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>نوع کاربر:</label>
                <select v-model="percentFilters.role" class="form-select">
                  <option value="">همه</option>
                  <option value="doctor">پزشک</option>
                  <option value="operator">اپراتور</option>
                </select>
              </div>
              <div class="filter-group">
                <label>نام:</label>
                <input v-model="percentFilters.name" type="text" placeholder="جستجو نام..." class="form-input" />
              </div>
            </div>
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearPercentFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generatePercentReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportPercentToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printPercentReport" />
              </div>
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ percentReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ percentReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ percentReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-content">
          <div class="desktop-table">
            <BaseTable
              :items="paginatedPercentRows"
              :empty-colspan="6"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>نام</th>
                  <th>نقش</th>
                  <th>تعداد خدمات/نوبت</th>
                  <th>مبلغ کل</th>
                  <th>درصد</th>
                </tr>
              </template>
              <template #row="{ item: row, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ row.name }}</td>
                  <td>{{ row.roleText }}</td>
                  <td>{{ row.count }}</td>
                  <td>{{ formatNumber(row.totalAmount) }} ریال</td>
                  <td>{{ row.percentage }}%</td>
              </template>
            </BaseTable>
          </div>
          
          <!-- Mobile Table for Doctors/Operators Percentage -->
          <div class="mobile-table">
            <div v-for="(row, index) in paginatedPercentRows" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام:</span>
                    <span class="mobile-value">{{ row.name }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">تعداد خدمات/نوبت:</span>
                    <span class="mobile-value">{{ row.count }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">مبلغ کل:</span>
                    <span class="mobile-value">{{ formatNumber(row.totalAmount) }} ریال</span>
                  </div>
                </div>
                <button @click="showPercentDetails(row)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for Doctors/Operators Percentage -->
          <div class="pagination-container" v-if="totalPercentPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentPercentPage }} از {{ totalPercentPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousPercentPage" 
                  :disabled="currentPercentPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextPercentPage" 
                  :disabled="currentPercentPage === totalPercentPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentPercentPage - 1) * percentItemsPerPage) + 1 }} تا {{ Math.min(currentPercentPage * percentItemsPerPage, filteredPercentRows.length) }} از {{ filteredPercentRows.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد افراد:</span>
              <span>{{ filteredPercentRows.length }}</span>
            </div>
            <div class="summary-item">
              <span>جمع مبلغ:</span>
              <span>{{ formatNumber(totalPercentAmount) }} ریال</span>
            </div>
          </div>
        </div>
      </div>

      <!-- تب گزارش ارسال پیامک -->
      <div v-if="activeTab === 'sms-report'" class="report-tab">
        <div class="report-header">
          <div class="report-filters">
            <div class="filters-grid">
              <div class="filter-group">
                <label>از تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="smsFilters.fromDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>تا تاریخ:</label>
                <div class="p-date">
                  <DatePicker
                    v-model="smsFilters.toDate"
                    format="jYYYY/jMM/jDD"
                    display-format="jYYYY/jMM/jDD"
                    :editable="true"
                    :clearable="false"
                    :auto-submit="true"
                    :show-now-btn="false"
                    placeholder="انتخاب تاریخ"
                    class="form-date-picker"
                    input-class="form-input"
                  />
                </div>
              </div>
              <div class="filter-group">
                <label>وضعیت ارسال:</label>
                <select v-model="smsFilters.status" class="form-select">
                  <option value="">همه</option>
                  <option value="sent">ارسال شد</option>
                  <option value="failed">ناموفق</option>
                  <option value="queued">در صف</option>
                </select>
              </div>
              <div class="filter-group">
                <label>شماره/نام:</label>
                <input v-model="smsFilters.query" type="text" placeholder="نام یا شماره..." class="form-input" />
              </div>
              <div class="filter-group">
                <label>متن ارسالی:</label>
                <input v-model="smsFilters.messageText" type="text" placeholder="بخشی از متن پیام..." class="form-input" />
              </div>
            </div>
            <div class="filter-actions">
              <div class="actions-buttons">
                <BaseButton title="پاک کردن فیلترها" variant="outline-danger" type="button" @click="clearSmsFilters" />
                <BaseButton title="تولید گزارش" variant="primary" type="button" @click="generateSmsReport" />
                <BaseButton title="خروجی اکسل" variant="outline-success" type="button" @click="exportSmsToExcel" />
                <BaseButton title="چاپ" variant="outline" type="button" @click="printSmsReport" />
              </div>
              <div class="report-info">
                <div class="info-item">
                  <label>کاربر ثبت کننده:</label>
                  <span>{{ smsReportInfo.createdBy }}</span>
                </div>
                <div class="info-item">
                  <label>تاریخ ثبت:</label>
                  <span>{{ smsReportInfo.createdDate }}</span>
                </div>
                <div class="info-item">
                  <label>ساعت ثبت:</label>
                  <span>{{ smsReportInfo.createdTime }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="report-content">
          <div class="desktop-table sms-desktop-table">
            <BaseTable
              :items="paginatedSmsLogs"
              :empty-colspan="8"
              :row-key="(_, index) => index"
            >
              <template #head>
                <tr>
                  <th>ردیف</th>
                  <th>تاریخ</th>
                  <th>ساعت</th>
                  <th>گیرنده</th>
                  <th>نام</th>
                  <th>نوع گیرنده</th>
                  <th>وضعیت</th>
                  <th>متن پیام</th>
                </tr>
              </template>
              <template #row="{ item: sms, index }">
                  <td>{{ index + 1 }}</td>
                  <td>{{ sms.date }}</td>
                  <td>{{ sms.time }}</td>
                  <td>{{ sms.to }}</td>
                  <td>{{ sms.name || '-' }}</td>
                  <td>{{ sms.recipientText }}</td>
                  <td>{{ sms.statusText }}</td>
                  <td>{{ sms.message }}</td>
              </template>
            </BaseTable>
          </div>
          
          <!-- Mobile Table for SMS Report -->
          <div class="mobile-table">
            <div v-for="(sms, index) in paginatedSmsLogs" :key="index" class="mobile-table-row">
              <div class="mobile-row-header">
                <div class="mobile-row-info">
                  <div class="mobile-info-item">
                    <span class="mobile-label">تاریخ:</span>
                    <span class="mobile-value">{{ sms.date }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">نام:</span>
                    <span class="mobile-value">{{ sms.name || '-' }}</span>
                  </div>
                  <div class="mobile-info-item">
                    <span class="mobile-label">وضعیت:</span>
                    <span class="mobile-value">{{ sms.statusText }}</span>
                  </div>
                </div>
                <button @click="showSmsDetails(sms)" class="mobile-view-btn">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Pagination Controls for SMS Report -->
          <div class="pagination-container" v-if="totalSmsPages > 1">
            <div class="pagination-layout">
              <div class="pagination-page-info">
                <span>صفحه {{ currentSmsPage }} از {{ totalSmsPages }}</span>
              </div>
              
              <div class="pagination-controls">
                <button 
                  @click="goToPreviousSmsPage" 
                  :disabled="currentSmsPage === 1"
                  class="pagination-btn pagination-prev"
                >
                  قبلی
                </button>
                
                <button 
                  @click="goToNextSmsPage" 
                  :disabled="currentSmsPage === totalSmsPages"
                  class="pagination-btn pagination-next"
                >
                  بعدی
                </button>
              </div>
              
              <div class="pagination-record-info">
                <span>نمایش {{ ((currentSmsPage - 1) * smsItemsPerPage) + 1 }} تا {{ Math.min(currentSmsPage * smsItemsPerPage, filteredSmsLogs.length) }} از {{ filteredSmsLogs.length }} رکورد</span>
              </div>
            </div>
          </div>
          
          <div class="report-summary">
            <div class="summary-item">
              <span>تعداد پیامک‌ها:</span>
              <span>{{ filteredSmsLogs.length }}</span>
            </div>
            <div class="summary-item">
              <span>موفق:</span>
              <span>{{ sentSmsCount }}</span>
            </div>
            <div class="summary-item">
              <span>ناموفق:</span>
              <span>{{ failedSmsCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Appointment Details Modal -->
  <div v-if="showAppointmentModal" class="modal-overlay">
      <div class="modal-content" @click.stop>
        <ModalHeader>
          <template #default>
            <h3>جزئیات نوبت</h3>
          </template>
          <template #actions>
            <button @click="closeAppointmentModal" class="modal-close-btn">×</button>
          </template>
        </ModalHeader>
        <div class="modal-body" v-if="selectedAppointmentDetails">
          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">تاریخ:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.date }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">ساعت:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.time }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">نام بیمار:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.patientName }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">نام پزشک:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.doctorName }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">اپراتور:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.operatorName || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">تلفن همراه:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.mobileNumber || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">وضعیت:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.statusText }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">توضیحات:</span>
              <span class="detail-value">{{ selectedAppointmentDetails.description || '-' }}</span>
            </div>
          </div>
          
          <!-- Scroll Indicator -->
          <div class="scroll-indicator">
            <div class="scroll-arrow">
              <span class="arrow-down">↓</span>
            </div>
            <span class="scroll-text">اسکرول کنید</span>
          </div>
        </div>
      </div>
    </div>

    <!-- SMS Details Modal -->
  <div v-if="showSmsModal" class="modal-overlay">
      <div class="modal-content" @click.stop>
        <ModalHeader>
          <template #default>
            <h3>جزئیات پیامک</h3>
          </template>
          <template #actions>
            <button @click="closeSmsModal" class="modal-close-btn">×</button>
          </template>
        </ModalHeader>
        <div class="modal-body" v-if="selectedSmsDetails">
          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">تاریخ:</span>
              <span class="detail-value">{{ selectedSmsDetails.date }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">ساعت:</span>
              <span class="detail-value">{{ selectedSmsDetails.time }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">گیرنده:</span>
              <span class="detail-value">{{ selectedSmsDetails.to }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">نام:</span>
              <span class="detail-value">{{ selectedSmsDetails.name || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">نوع گیرنده:</span>
              <span class="detail-value">{{ selectedSmsDetails.recipientText }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">وضعیت:</span>
              <span class="detail-value">{{ selectedSmsDetails.statusText }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">متن پیام:</span>
              <span class="detail-value">{{ selectedSmsDetails.message }}</span>
            </div>
          </div>
          
          <!-- Scroll Indicator -->
          <div class="scroll-indicator">
            <div class="scroll-arrow">
              <span class="arrow-down">↓</span>
            </div>
            <span class="scroll-text">اسکرول کنید</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Percent Details Modal -->
  <div v-if="showPercentModal" class="modal-overlay">
      <div class="modal-content" @click.stop>
        <ModalHeader>
          <template #default>
            <h3>جزئیات درصد پزشک/اپراتور</h3>
          </template>
          <template #actions>
            <button @click="closePercentModal" class="modal-close-btn">×</button>
          </template>
        </ModalHeader>
        <div class="modal-body" v-if="selectedPercentDetails">
          <div class="payment-details">
            <div class="detail-row">
              <span class="detail-label">نام:</span>
              <span class="detail-value">{{ selectedPercentDetails.name }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">نقش:</span>
              <span class="detail-value">{{ selectedPercentDetails.roleText }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">تعداد خدمات/نوبت:</span>
              <span class="detail-value">{{ selectedPercentDetails.count }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">مبلغ کل:</span>
              <span class="detail-value">{{ formatNumber(selectedPercentDetails.totalAmount) }} ریال</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">درصد:</span>
              <span class="detail-value">{{ selectedPercentDetails.percentage }}%</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">تاریخ شروع:</span>
              <span class="detail-value">{{ percentFilters.fromDate || '-' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">تاریخ پایان:</span>
              <span class="detail-value">{{ percentFilters.toDate || '-' }}</span>
            </div>
          </div>
          
          <!-- Scroll Indicator -->
          <div class="scroll-indicator">
            <div class="scroll-arrow">
              <span class="arrow-down">↓</span>
            </div>
            <span class="scroll-text">اسکرول کنید</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Info handled by PageHeader -->
</template>

<script setup>
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import BaseTable from '@/components/UiCompunents/BaseTable.vue'
import PageHeader from '@/components/PageHeader.vue';
import { ref, computed, onMounted } from 'vue'
import DatePicker from 'vue3-persian-datetime-picker'
import ModalHeader from '@/components/ModalHeader.vue'
import moment from 'jalali-moment'

// Tab state
const activeTab = ref('patient-payments')

// Mobile dropdown state for patient payments filters
const showMoreFilters = ref(false)

// Mobile dropdown state for unsettled bills filters
const showMoreUnsettledFilters = ref(false)

// Mobile dropdown state for bills-services filters
const showMoreBillsServicesFilters = ref(false)

// Mobile table modal state
const selectedPaymentDetails = ref(null)
const showPaymentModal = ref(false)

// Unsettled bills modal state
const selectedUnsettledBillDetails = ref(null)
const showUnsettledBillModal = ref(false)

// Bills-services modal state
const selectedBillsServicesDetails = ref(null)
const showBillsServicesModal = ref(false)

// Percent modal state
const selectedPercentDetails = ref(null)
const showPercentModal = ref(false)

// Appointments modal state
const selectedAppointmentDetails = ref(null)
const showAppointmentModal = ref(false)

// Inventory modal state
const selectedInventoryDetails = ref(null)
const showInventoryModal = ref(false)

// SMS modal state
const selectedSmsDetails = ref(null)
const showSmsModal = ref(false)

// Info modal is handled by PageHeader; Info link is provided via infoLearnUrl
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/'

// Pagination state for patient payments
const currentPage = ref(1)
const itemsPerPage = 5

// Pagination state for unsettled bills
const currentUnsettledPage = ref(1)
const unsettledItemsPerPage = 5

// Pagination state for bills and services
const currentBillsServicesPage = ref(1)
const billsServicesItemsPerPage = 5

// Pagination state for inventory
const currentInventoryPage = ref(1)
const inventoryItemsPerPage = 5

// Pagination state for appointments
const currentAppointmentsPage = ref(1)
const appointmentsItemsPerPage = 5

// Pagination state for doctors/operators percentage
const currentPercentPage = ref(1)
const percentItemsPerPage = 5

// Pagination state for SMS report
const currentSmsPage = ref(1)
const smsItemsPerPage = 5

// Filters
const filters = ref({
  fromDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().format('jYYYY/jMM/jDD'),
  doctorName: '',
  patientName: '',
  phoneNumber: '',
  mobileNumber: '',
  paymentType: '',
  fileNumber: '',
  documentNumber: '',
  referrerName: '',
  purpose: '',
  description: '',
  intermediary: '',
  showValidBills: true,
  showInvalidBills: false
})

// Unsettled bills filters
const unsettledFilters = ref({
  fromBillNumber: '',
  toBillNumber: '',
  fromRegistrationDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toRegistrationDate: moment().format('jYYYY/jMM/jDD'),
  doctorName: '',
  patientName: '',
  fileNumber: '',
  phoneNumber: '',
  mobileNumber: '',
  intermediary: '',
  createdBy: '',
  showValidBills: true,
  showInvalidBills: false
})

// Bills and services filters
const billsServicesFilters = ref({
  fromBillNumber: '',
  toBillNumber: '',
  fromDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().format('jYYYY/jMM/jDD'),
  fromRegistrationDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toRegistrationDate: moment().format('jYYYY/jMM/jDD'),
  doctorName: '',
  patientName: '',
  fileNumber: '',
  phoneNumber: '',
  mobileNumber: '',
  createdBy: '',
  description: '',
  serviceName: '',
  serviceCode: '',
  intermediary: '',
  showValidBills: true,
  showInvalidBills: false
})

// Inventory filters
const inventoryFilters = ref({
  fromDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().format('jYYYY/jMM/jDD'),
  itemName: ''
})

const inventorySearch = ref('')

// Report info
const reportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: moment().format('jYYYY/jMM/jDD'),
  createdTime: moment().format('HH:mm:ss')
})

// Unsettled report info
const unsettledReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: '1404/07/27',
  createdTime: '11:37:39'
})

// Bills services report info
const billsServicesReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: '1404/07/27',
  createdTime: '11:37:39'
})

// Inventory report info
const inventoryReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: '1404/07/27',
  createdTime: '11:37:39'
})

// Appointments filters & report info
const appointmentsFilters = ref({
  fromDate: moment().subtract(7, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().add(7, 'days').format('jYYYY/jMM/jDD'),
  doctorName: '',
  operatorName: '',
  patientName: '',
  status: ''
})

const appointmentsReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: moment().format('jYYYY/jMM/jDD'),
  createdTime: moment().format('HH:mm:ss')
})

// Doctors/operators percentage filters & report info
const percentFilters = ref({
  fromDate: moment().subtract(30, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().format('jYYYY/jMM/jDD'),
  role: '',
  name: ''
})

const percentReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: moment().format('jYYYY/jMM/jDD'),
  createdTime: moment().format('HH:mm:ss')
})

// SMS filters & report info
const smsFilters = ref({
  fromDate: moment().subtract(7, 'days').format('jYYYY/jMM/jDD'),
  toDate: moment().format('jYYYY/jMM/jDD'),
  messageText: '',
  status: '',
  query: ''
})

const smsReportInfo = ref({
  createdBy: 'مدیر سیستم',
  createdDate: moment().format('jYYYY/jMM/jDD'),
  createdTime: moment().format('HH:mm:ss')
})

// Sample data for patient payments
const patientPayments = ref([
  {
    patientName: 'احمد محمدی',
    doctorName: 'دکتر علی رضایی',
    nationalId: '1234567890',
    mobileNumber: '09123456789',
    phoneNumber: '02112345678',
    fileNumber: 'F001',
    documentNumber: 'D001',
    referrerName: 'محمد احمدی',
    purpose: 'معاینه عمومی',
    serviceName: 'معاینه عمومی',
    serviceCode: 'S001',
    amount: 150000,
    insuranceAmount: 45000,
    patientAmount: 105000,
    totalAmount: 150000,
    paymentDate: '1403/09/15',
    invoiceDate: '1403/09/15',
    invoiceNumber: 'INV-001',
    paymentType: 'نقدی',
    intermediary: 'خود بیمار',
    description: 'پرداخت نقدی معاینه',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/15',
    createdTime: '10:30:00',
    percentage: '100%'
  },
  {
    patientName: 'فاطمه احمدی',
    doctorName: 'دکتر مریم حسینی',
    nationalId: '0987654321',
    mobileNumber: '09987654321',
    phoneNumber: '02187654321',
    fileNumber: 'F002',
    documentNumber: 'D002',
    referrerName: 'علی محمدی',
    purpose: 'آزمایش خون',
    serviceName: 'آزمایش خون',
    serviceCode: 'S002',
    amount: 200000,
    insuranceAmount: 60000,
    patientAmount: 140000,
    totalAmount: 200000,
    paymentDate: '1403/09/16',
    invoiceDate: '1403/09/16',
    invoiceNumber: 'INV-002',
    paymentType: 'کارت',
    intermediary: 'بیمه',
    description: 'پرداخت با کارت بانکی',
    createdBy: 'کاربر 1',
    createdDate: '1403/09/16',
    createdTime: '14:15:00',
    percentage: '100%'
  },
  {
    patientName: 'علی رضایی',
    doctorName: 'دکتر علی رضایی',
    nationalId: '1122334455',
    mobileNumber: '0911223344',
    phoneNumber: '02111223344',
    fileNumber: 'F003',
    documentNumber: 'D003',
    referrerName: '',
    purpose: 'سونوگرافی',
    serviceName: 'سونوگرافی',
    serviceCode: 'S003',
    amount: 300000,
    insuranceAmount: 90000,
    patientAmount: 210000,
    totalAmount: 300000,
    paymentDate: '1403/09/17',
    invoiceDate: '1403/09/17',
    invoiceNumber: 'INV-003',
    paymentType: 'چک',
    intermediary: 'خود بیمار',
    description: 'پرداخت با چک',
    createdBy: 'کاربر 2',
    createdDate: '1403/09/17',
    createdTime: '16:45:00',
    percentage: '100%'
  },
  {
    patientName: 'سارا احمدی',
    doctorName: 'دکتر مریم حسینی',
    nationalId: '2233445566',
    mobileNumber: '0922334455',
    phoneNumber: '02122334455',
    fileNumber: 'F004',
    documentNumber: 'D004',
    referrerName: 'محمد احمدی',
    purpose: 'عکس رادیولوژی',
    serviceName: 'عکس رادیولوژی',
    serviceCode: 'S004',
    amount: 180000,
    insuranceAmount: 54000,
    patientAmount: 126000,
    totalAmount: 180000,
    paymentDate: '1403/09/18',
    invoiceDate: '1403/09/18',
    invoiceNumber: 'INV-004',
    paymentType: 'نقدی',
    intermediary: 'خود بیمار',
    description: 'پرداخت نقدی عکس رادیولوژی',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/18',
    createdTime: '09:15:00',
    percentage: '100%'
  },
  {
    patientName: 'محمد رضایی',
    doctorName: 'دکتر احمد محمدی',
    nationalId: '3344556677',
    mobileNumber: '0933445566',
    phoneNumber: '02133445566',
    fileNumber: 'F005',
    documentNumber: 'D005',
    referrerName: 'علی محمدی',
    purpose: 'آزمایش ادرار',
    serviceName: 'آزمایش ادرار',
    serviceCode: 'S005',
    amount: 120000,
    insuranceAmount: 36000,
    patientAmount: 84000,
    totalAmount: 120000,
    paymentDate: '1403/09/19',
    invoiceDate: '1403/09/19',
    invoiceNumber: 'INV-005',
    paymentType: 'کارت',
    intermediary: 'بیمه',
    description: 'پرداخت با کارت بانکی',
    createdBy: 'کاربر 1',
    createdDate: '1403/09/19',
    createdTime: '11:30:00',
    percentage: '100%'
  },
  {
    patientName: 'زهرا محمدی',
    doctorName: 'دکتر علی رضایی',
    nationalId: '4455667788',
    mobileNumber: '0944556677',
    phoneNumber: '02144556677',
    fileNumber: 'F006',
    documentNumber: 'D006',
    referrerName: '',
    purpose: 'معاینه قلب',
    serviceName: 'معاینه قلب',
    serviceCode: 'S006',
    amount: 250000,
    insuranceAmount: 75000,
    patientAmount: 175000,
    totalAmount: 250000,
    paymentDate: '1403/09/20',
    invoiceDate: '1403/09/20',
    invoiceNumber: 'INV-006',
    paymentType: 'چک',
    intermediary: 'خود بیمار',
    description: 'پرداخت با چک',
    createdBy: 'کاربر 2',
    createdDate: '1403/09/20',
    createdTime: '14:20:00',
    percentage: '100%'
  },
  {
    patientName: 'حسن احمدی',
    doctorName: 'دکتر مریم حسینی',
    nationalId: '5566778899',
    mobileNumber: '0955667788',
    phoneNumber: '02155667788',
    fileNumber: 'F007',
    documentNumber: 'D007',
    referrerName: 'فاطمه احمدی',
    purpose: 'آزمایش قند خون',
    serviceName: 'آزمایش قند خون',
    serviceCode: 'S007',
    amount: 80000,
    insuranceAmount: 24000,
    patientAmount: 56000,
    totalAmount: 80000,
    paymentDate: '1403/09/21',
    invoiceDate: '1403/09/21',
    invoiceNumber: 'INV-007',
    paymentType: 'نقدی',
    intermediary: 'خود بیمار',
    description: 'پرداخت نقدی آزمایش',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/21',
    createdTime: '08:45:00',
    percentage: '100%'
  },
  {
    patientName: 'مریم رضایی',
    doctorName: 'دکتر احمد محمدی',
    nationalId: '6677889900',
    mobileNumber: '0966778899',
    phoneNumber: '02166778899',
    fileNumber: 'F008',
    documentNumber: 'D008',
    referrerName: 'علی رضایی',
    purpose: 'سونوگرافی شکم',
    serviceName: 'سونوگرافی شکم',
    serviceCode: 'S008',
    amount: 220000,
    insuranceAmount: 66000,
    patientAmount: 154000,
    totalAmount: 220000,
    paymentDate: '1403/09/22',
    invoiceDate: '1403/09/22',
    invoiceNumber: 'INV-008',
    paymentType: 'کارت',
    intermediary: 'بیمه',
    description: 'پرداخت با کارت بانکی',
    createdBy: 'کاربر 1',
    createdDate: '1403/09/22',
    createdTime: '13:10:00',
    percentage: '100%'
  },
  {
    patientName: 'علی احمدی',
    doctorName: 'دکتر علی رضایی',
    nationalId: '7788990011',
    mobileNumber: '0977889900',
    phoneNumber: '02177889900',
    fileNumber: 'F009',
    documentNumber: 'D009',
    referrerName: '',
    purpose: 'معاینه چشم',
    serviceName: 'معاینه چشم',
    serviceCode: 'S009',
    amount: 160000,
    insuranceAmount: 48000,
    patientAmount: 112000,
    totalAmount: 160000,
    paymentDate: '1403/09/23',
    invoiceDate: '1403/09/23',
    invoiceNumber: 'INV-009',
    paymentType: 'نقدی',
    intermediary: 'خود بیمار',
    description: 'پرداخت نقدی معاینه چشم',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/23',
    createdTime: '10:00:00',
    percentage: '100%'
  },
  {
    patientName: 'فاطمه رضایی',
    doctorName: 'دکتر مریم حسینی',
    nationalId: '8899001122',
    mobileNumber: '0988990011',
    phoneNumber: '02188990011',
    fileNumber: 'F010',
    documentNumber: 'D010',
    referrerName: 'محمد رضایی',
    purpose: 'آزمایش تیروئید',
    serviceName: 'آزمایش تیروئید',
    serviceCode: 'S010',
    amount: 140000,
    insuranceAmount: 42000,
    patientAmount: 98000,
    totalAmount: 140000,
    paymentDate: '1403/09/24',
    invoiceDate: '1403/09/24',
    invoiceNumber: 'INV-010',
    paymentType: 'چک',
    intermediary: 'خود بیمار',
    description: 'پرداخت با چک آزمایش',
    createdBy: 'کاربر 2',
    createdDate: '1403/09/24',
    createdTime: '15:30:00',
    percentage: '100%'
  },
  {
    patientName: 'احمد رضایی',
    doctorName: 'دکتر احمد محمدی',
    nationalId: '9900112233',
    mobileNumber: '0999001122',
    phoneNumber: '02199001122',
    fileNumber: 'F011',
    documentNumber: 'D011',
    referrerName: 'زهرا محمدی',
    purpose: 'عکس قفسه سینه',
    serviceName: 'عکس قفسه سینه',
    serviceCode: 'S011',
    amount: 190000,
    insuranceAmount: 57000,
    patientAmount: 133000,
    totalAmount: 190000,
    paymentDate: '1403/09/25',
    invoiceDate: '1403/09/25',
    invoiceNumber: 'INV-011',
    paymentType: 'کارت',
    intermediary: 'بیمه',
    description: 'پرداخت با کارت بانکی',
    createdBy: 'کاربر 1',
    createdDate: '1403/09/25',
    createdTime: '12:45:00',
    percentage: '100%'
  },
  {
    patientName: 'سارا محمدی',
    doctorName: 'دکتر علی رضایی',
    nationalId: '0011223344',
    mobileNumber: '0900112233',
    phoneNumber: '02100112233',
    fileNumber: 'F012',
    documentNumber: 'D012',
    referrerName: '',
    purpose: 'معاینه گوش',
    serviceName: 'معاینه گوش',
    serviceCode: 'S012',
    amount: 110000,
    insuranceAmount: 33000,
    patientAmount: 77000,
    totalAmount: 110000,
    paymentDate: '1403/09/26',
    invoiceDate: '1403/09/26',
    invoiceNumber: 'INV-012',
    paymentType: 'نقدی',
    intermediary: 'خود بیمار',
    description: 'پرداخت نقدی معاینه گوش',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/26',
    createdTime: '16:20:00',
    percentage: '100%'
  },
  {
    patientName: 'محمد حسینی',
    doctorName: 'دکتر مریم حسینی',
    nationalId: '1122334455',
    mobileNumber: '0911223344',
    phoneNumber: '02111223344',
    fileNumber: 'F013',
    documentNumber: 'D013',
    referrerName: 'حسن احمدی',
    purpose: 'آزمایش کلسترول',
    serviceName: 'آزمایش کلسترول',
    serviceCode: 'S013',
    amount: 130000,
    insuranceAmount: 39000,
    patientAmount: 91000,
    totalAmount: 130000,
    paymentDate: '1403/09/27',
    invoiceDate: '1403/09/27',
    invoiceNumber: 'INV-013',
    paymentType: 'چک',
    intermediary: 'خود بیمار',
    description: 'پرداخت با چک آزمایش',
    createdBy: 'کاربر 2',
    createdDate: '1403/09/27',
    createdTime: '09:30:00',
    percentage: '100%'
  },
  { invoiceNumber: 'INV-004', patientName: 'زهرا محمدی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F004', phoneNumber: '02111112222', mobileNumber: '09111112222', intermediary: 'بیمه', createdBy: 'کاربر 1', createdDate: '1403/09/18', createdTime: '09:10:00', invoiceDate: '1403/09/18', issueDate: '1403/09/18', amount: 180000, remainingAmount: 180000, payableAmount: 180000, insuranceAmount: 54000, patientAmount: 126000, totalAmount: 180000, isCancelled: false },
  { invoiceNumber: 'INV-005', patientName: 'سارا احمدی', doctorName: 'دکتر احمد محمدی', fileNumber: 'F005', phoneNumber: '02122223333', mobileNumber: '09122223333', intermediary: 'خود بیمار', createdBy: 'مدیر سیستم', createdDate: '1403/09/19', createdTime: '11:20:00', invoiceDate: '1403/09/19', issueDate: '1403/09/19', amount: 120000, remainingAmount: 120000, payableAmount: 120000, insuranceAmount: 36000, patientAmount: 84000, totalAmount: 120000, isCancelled: false },
  { invoiceNumber: 'INV-006', patientName: 'محمد رضایی', doctorName: 'دکتر علی رضایی', fileNumber: 'F006', phoneNumber: '02133334444', mobileNumber: '09133334444', intermediary: 'خود بیمار', createdBy: 'کاربر 2', createdDate: '1403/09/20', createdTime: '14:40:00', invoiceDate: '1403/09/20', issueDate: '1403/09/20', amount: 250000, remainingAmount: 250000, payableAmount: 250000, insuranceAmount: 75000, patientAmount: 175000, totalAmount: 250000, isCancelled: false },
  { invoiceNumber: 'INV-007', patientName: 'فاطمه احمدی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F007', phoneNumber: '02144445555', mobileNumber: '09144445555', intermediary: 'بیمه', createdBy: 'کاربر 1', createdDate: '1403/09/21', createdTime: '08:55:00', invoiceDate: '1403/09/21', issueDate: '1403/09/21', amount: 80000, remainingAmount: 80000, payableAmount: 80000, insuranceAmount: 24000, patientAmount: 56000, totalAmount: 80000, isCancelled: false },
  { invoiceNumber: 'INV-008', patientName: 'حسن احمدی', doctorName: 'دکتر احمد محمدی', fileNumber: 'F008', phoneNumber: '02155556666', mobileNumber: '09155556666', intermediary: 'خود بیمار', createdBy: 'مدیر سیستم', createdDate: '1403/09/22', createdTime: '10:05:00', invoiceDate: '1403/09/22', issueDate: '1403/09/22', amount: 220000, remainingAmount: 220000, payableAmount: 220000, insuranceAmount: 66000, patientAmount: 154000, totalAmount: 220000, isCancelled: false },
  { invoiceNumber: 'INV-009', patientName: 'مریم رضایی', doctorName: 'دکتر علی رضایی', fileNumber: 'F009', phoneNumber: '02166667777', mobileNumber: '09166667777', intermediary: 'خود بیمار', createdBy: 'کاربر 2', createdDate: '1403/09/23', createdTime: '12:25:00', invoiceDate: '1403/09/23', issueDate: '1403/09/23', amount: 160000, remainingAmount: 160000, payableAmount: 160000, insuranceAmount: 48000, patientAmount: 112000, totalAmount: 160000, isCancelled: true },
  { invoiceNumber: 'INV-010', patientName: 'علی احمدی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F010', phoneNumber: '02177778888', mobileNumber: '09177778888', intermediary: 'بیمه', createdBy: 'کاربر 1', createdDate: '1403/09/24', createdTime: '15:15:00', invoiceDate: '1403/09/24', issueDate: '1403/09/24', amount: 140000, remainingAmount: 140000, payableAmount: 140000, insuranceAmount: 42000, patientAmount: 98000, totalAmount: 140000, isCancelled: false },
  { invoiceNumber: 'INV-011', patientName: 'احمد رضایی', doctorName: 'دکتر احمد محمدی', fileNumber: 'F011', phoneNumber: '02188889999', mobileNumber: '09188889999', intermediary: 'خود بیمار', createdBy: 'مدیر سیستم', createdDate: '1403/09/25', createdTime: '17:30:00', invoiceDate: '1403/09/25', issueDate: '1403/09/25', amount: 190000, remainingAmount: 190000, payableAmount: 190000, insuranceAmount: 57000, patientAmount: 133000, totalAmount: 190000, isCancelled: false },
  { invoiceNumber: 'INV-012', patientName: 'سارا محمدی', doctorName: 'دکتر علی رضایی', fileNumber: 'F012', phoneNumber: '02199990000', mobileNumber: '09199990000', intermediary: 'خود بیمار', createdBy: 'کاربر 2', createdDate: '1403/09/26', createdTime: '09:45:00', invoiceDate: '1403/09/26', issueDate: '1403/09/26', amount: 110000, remainingAmount: 110000, payableAmount: 110000, insuranceAmount: 33000, patientAmount: 77000, totalAmount: 110000, isCancelled: false },
  { invoiceNumber: 'INV-013', patientName: 'محمد حسینی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F013', phoneNumber: '02100001111', mobileNumber: '09100001111', intermediary: 'بیمه', createdBy: 'کاربر 1', createdDate: '1403/09/27', createdTime: '11:35:00', invoiceDate: '1403/09/27', issueDate: '1403/09/27', amount: 130000, remainingAmount: 130000, payableAmount: 130000, insuranceAmount: 39000, patientAmount: 91000, totalAmount: 130000, isCancelled: false }
])

// Doctors list for filter
const doctorsList = ref([
  { id: 1, name: 'دکتر علی رضایی' },
  { id: 2, name: 'دکتر مریم حسینی' },
  { id: 3, name: 'دکتر احمد محمدی' }
])

// Sample data for unsettled bills
const unsettledBills = ref([
  {
    invoiceNumber: 'INV-001',
    patientName: 'علی رضایی',
    doctorName: 'دکتر علی رضایی',
    fileNumber: 'F001',
    phoneNumber: '02112345678',
    mobileNumber: '09123456789',
    intermediary: 'خود بیمار',
    createdBy: 'مدیر سیستم',
    createdDate: '1403/09/10',
    createdTime: '10:30:00',
    invoiceDate: '1403/09/10',
    issueDate: '1403/09/10',
    amount: 300000,
    remainingAmount: 300000,
    payableAmount: 300000,
    insuranceAmount: 90000,
    patientAmount: 210000,
    totalAmount: 300000,
    isCancelled: false
  },
  {
    invoiceNumber: 'INV-002',
    patientName: 'مریم حسینی',
    doctorName: 'دکتر مریم حسینی',
    fileNumber: 'F002',
    phoneNumber: '02187654321',
    mobileNumber: '09987654321',
    intermediary: 'بیمه',
    createdBy: 'کاربر 1',
    createdDate: '1403/09/12',
    createdTime: '14:15:00',
    invoiceDate: '1403/09/12',
    issueDate: '1403/09/12',
    amount: 250000,
    remainingAmount: 250000,
    payableAmount: 250000,
    insuranceAmount: 75000,
    patientAmount: 175000,
    totalAmount: 250000,
    isCancelled: false
  },
  {
    invoiceNumber: 'INV-003',
    patientName: 'احمد محمدی',
    doctorName: 'دکتر علی رضایی',
    fileNumber: 'F003',
    phoneNumber: '02111223344',
    mobileNumber: '0911223344',
    intermediary: 'خود بیمار',
    createdBy: 'کاربر 2',
    createdDate: '1403/09/15',
    createdTime: '16:45:00',
    invoiceDate: '1403/09/15',
    issueDate: '1403/09/15',
    amount: 400000,
    remainingAmount: 400000,
    payableAmount: 400000,
    insuranceAmount: 120000,
    patientAmount: 280000,
    totalAmount: 400000,
    isCancelled: true
  },
  { invoiceNumber: 'INV-005', patientName: 'زهرا محمدی', doctorName: 'دکتر احمد محمدی', fileNumber: 'F005', phoneNumber: '02122334455', mobileNumber: '09122334455', createdBy: 'کاربر 1', description: 'آزمایش تیروئید', serviceName: 'آزمایش تیروئید', serviceCode: 'S005', intermediary: 'بیمه', quantity: 1, unitPrice: 140000, totalPrice: 140000, insuranceAmount: 42000, patientAmount: 98000, invoiceDate: '1403/09/19', date: '1403/09/19', createdDate: '1403/09/19', createdTime: '11:30:00', isCancelled: false },
  { invoiceNumber: 'INV-006', patientName: 'سارا احمدی', doctorName: 'دکتر علی رضایی', fileNumber: 'F006', phoneNumber: '02133445566', mobileNumber: '09133445566', createdBy: 'مدیر سیستم', description: 'معاینه قلب', serviceName: 'معاینه قلب', serviceCode: 'S006', intermediary: 'خود بیمار', quantity: 1, unitPrice: 250000, totalPrice: 250000, insuranceAmount: 75000, patientAmount: 175000, invoiceDate: '1403/09/20', date: '1403/09/20', createdDate: '1403/09/20', createdTime: '14:20:00', isCancelled: false },
  { invoiceNumber: 'INV-007', patientName: 'محمد رضایی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F007', phoneNumber: '02144556677', mobileNumber: '09144556677', createdBy: 'کاربر 2', description: 'آزمایش قند خون', serviceName: 'آزمایش قند خون', serviceCode: 'S007', intermediary: 'بیمه', quantity: 1, unitPrice: 80000, totalPrice: 80000, insuranceAmount: 24000, patientAmount: 56000, invoiceDate: '1403/09/21', date: '1403/09/21', createdDate: '1403/09/21', createdTime: '08:45:00', isCancelled: false },
  { invoiceNumber: 'INV-008', patientName: 'حسن احمدی', doctorName: 'דکتر احمد محمدی', fileNumber: 'F008', phoneNumber: '02155667788', mobileNumber: '09155667788', createdBy: 'کاربر 1', description: 'سونوگرافی شکم', serviceName: 'سونوگرافی شکم', serviceCode: 'S008', intermediary: 'خود بیمار', quantity: 1, unitPrice: 220000, totalPrice: 220000, insuranceAmount: 66000, patientAmount: 154000, invoiceDate: '1403/09/22', date: '1403/09/22', createdDate: '1403/09/22', createdTime: '13:10:00', isCancelled: false },
  { invoiceNumber: 'INV-009', patientName: 'مریم رضایی', doctorName: 'دکتر علی رضایی', fileNumber: 'F009', phoneNumber: '02166778899', mobileNumber: '09166778899', createdBy: 'کاربر 2', description: 'معاینه چشم', serviceName: 'معاینه چشم', serviceCode: 'S009', intermediary: 'خود بیمار', quantity: 1, unitPrice: 160000, totalPrice: 160000, insuranceAmount: 48000, patientAmount: 112000, invoiceDate: '1403/09/23', date: '1403/09/23', createdDate: '1403/09/23', createdTime: '10:00:00', isCancelled: false },
  { invoiceNumber: 'INV-010', patientName: 'علی احمدی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F010', phoneNumber: '02177889900', mobileNumber: '09177889900', createdBy: 'کاربر 1', description: 'آزمایش تیروئید', serviceName: 'آزمایش تیروئید', serviceCode: 'S010', intermediary: 'بیمه', quantity: 1, unitPrice: 140000, totalPrice: 140000, insuranceAmount: 42000, patientAmount: 98000, invoiceDate: '1403/09/24', date: '1403/09/24', createdDate: '1403/09/24', createdTime: '15:30:00', isCancelled: false },
  { invoiceNumber: 'INV-011', patientName: 'احمد رضایی', doctorName: 'دکتر احمد محمدی', fileNumber: 'F011', phoneNumber: '02188990011', mobileNumber: '09188990011', createdBy: 'مدیر سیستم', description: 'عکس قفسه سینه', serviceName: 'عکس قفسه سینه', serviceCode: 'S011', intermediary: 'خود بیمار', quantity: 1, unitPrice: 190000, totalPrice: 190000, insuranceAmount: 57000, patientAmount: 133000, invoiceDate: '1403/09/25', date: '1403/09/25', createdDate: '1403/09/25', createdTime: '12:45:00', isCancelled: false },
  { invoiceNumber: 'INV-012', patientName: 'سارا محمدی', doctorName: 'دکتر علی رضایی', fileNumber: 'F012', phoneNumber: '02100112233', mobileNumber: '09100112233', createdBy: 'کاربر 2', description: 'معاینه گوش', serviceName: 'معاینه گوش', serviceCode: 'S012', intermediary: 'خود بیمار', quantity: 1, unitPrice: 110000, totalPrice: 110000, insuranceAmount: 33000, patientAmount: 77000, invoiceDate: '1403/09/26', date: '1403/09/26', createdDate: '1403/09/26', createdTime: '16:20:00', isCancelled: false },
  { invoiceNumber: 'INV-013', patientName: 'محمد حسینی', doctorName: 'دکتر مریم حسینی', fileNumber: 'F013', phoneNumber: '02111223344', mobileNumber: '09111223344', createdBy: 'کاربر 1', description: 'آزمایش کلسترول', serviceName: 'آزمایش کلسترول', serviceCode: 'S013', intermediary: 'خود بیمار', quantity: 1, unitPrice: 130000, totalPrice: 130000, insuranceAmount: 39000, patientAmount: 91000, invoiceDate: '1403/09/27', date: '1403/09/27', createdDate: '1403/09/27', createdTime: '09:30:00', isCancelled: false }
])

// Sample data for bills and services
const billsServices = ref([
  {
    invoiceNumber: 'INV-001',
    patientName: 'علی رضایی',
    doctorName: 'دکتر علی رضایی',
    fileNumber: 'F001',
    phoneNumber: '02112345678',
    mobileNumber: '09123456789',
    createdBy: 'مدیر سیستم',
    description: 'معاینه عمومی کامل',
    serviceName: 'معاینه عمومی',
    serviceCode: 'S001',
    intermediary: 'خود بیمار',
    quantity: 1,
    unitPrice: 100000,
    totalPrice: 100000,
    insuranceAmount: 30000,
    patientAmount: 70000,
    invoiceDate: '1403/09/15',
    date: '1403/09/15',
    createdDate: '1403/09/15',
    createdTime: '10:30:00',
    isCancelled: false
  },
  {
    invoiceNumber: 'INV-002',
    patientName: 'مریم حسینی',
    doctorName: 'دکتر مریم حسینی',
    fileNumber: 'F002',
    phoneNumber: '02187654321',
    mobileNumber: '09987654321',
    createdBy: 'کاربر 1',
    description: 'آزمایش خون کامل',
    serviceName: 'آزمایش خون',
    serviceCode: 'S002',
    intermediary: 'بیمه',
    quantity: 2,
    unitPrice: 50000,
    totalPrice: 100000,
    insuranceAmount: 60000,
    patientAmount: 40000,
    invoiceDate: '1403/09/16',
    date: '1403/09/16',
    createdDate: '1403/09/16',
    createdTime: '14:15:00',
    isCancelled: false
  },
  {
    invoiceNumber: 'INV-003',
    patientName: 'احمد محمدی',
    doctorName: 'دکتر علی رضایی',
    fileNumber: 'F003',
    phoneNumber: '02111223344',
    mobileNumber: '0911223344',
    createdBy: 'کاربر 2',
    description: 'سونوگرافی شکم',
    serviceName: 'سونوگرافی',
    serviceCode: 'S003',
    intermediary: 'خود بیمار',
    quantity: 1,
    unitPrice: 200000,
    totalPrice: 200000,
    insuranceAmount: 60000,
    patientAmount: 140000,
    invoiceDate: '1403/09/17',
    date: '1403/09/17',
    createdDate: '1403/09/17',
    createdTime: '16:45:00',
    isCancelled: true
  },
  {
    invoiceNumber: 'INV-004',
    patientName: 'فاطمه احمدی',
    doctorName: 'دکتر مریم حسینی',
    fileNumber: 'F004',
    phoneNumber: '02199887766',
    mobileNumber: '09199887766',
    createdBy: 'مدیر سیستم',
    description: 'رادیولوژی قفسه سینه',
    serviceName: 'رادیولوژی',
    serviceCode: 'S004',
    intermediary: 'بیمه',
    quantity: 1,
    unitPrice: 150000,
    totalPrice: 150000,
    insuranceAmount: 45000,
    patientAmount: 105000,
    invoiceDate: '1403/09/18',
    date: '1403/09/18',
    createdDate: '1403/09/18',
    createdTime: '09:20:00',
    isCancelled: false
  },
  { name: 'دستکش لاتکس', code: 'D001', currentStock: 120, minStock: 50, status: 'sufficient', unitPrice: 7000 },
  { name: 'سرم قندی 5%', code: 'SR001', currentStock: 30, minStock: 20, status: 'sufficient', unitPrice: 20000 },
  { name: 'بتادین', code: 'B001', currentStock: 8, minStock: 15, status: 'low', unitPrice: 15000 },
  { name: 'چسب زخم', code: 'CH001', currentStock: 0, minStock: 25, status: 'out', unitPrice: 3000 },
  { name: 'ماسک جراحی', code: 'M001', currentStock: 500, minStock: 200, status: 'sufficient', unitPrice: 1000 },
  { name: 'آمپول ویتامین D', code: 'A001', currentStock: 15, minStock: 30, status: 'low', unitPrice: 60000 },
  { name: 'پنبه الکلی', code: 'PE001', currentStock: 70, minStock: 40, status: 'sufficient', unitPrice: 4000 },
  { name: 'گلوکومتر', code: 'GL001', currentStock: 2, minStock: 5, status: 'low', unitPrice: 250000 },
  { name: 'تیغ بیستوری', code: 'TG001', currentStock: 0, minStock: 10, status: 'out', unitPrice: 5000 },
  { name: 'الکل سفید', code: 'AL001', currentStock: 60, minStock: 30, status: 'sufficient', unitPrice: 8000 }
])

// Sample data for inventory
const inventory = ref([
  {
    name: 'پنبه',
    code: 'P001',
    currentStock: 50,
    minStock: 20,
    status: 'sufficient',
    unitPrice: 5000
  },
  {
    name: 'سرنگ',
    code: 'S001',
    currentStock: 5,
    minStock: 15,
    status: 'low',
    unitPrice: 2000
  },
  {
    name: 'گاز استریل',
    code: 'G001',
    currentStock: 0,
    minStock: 10,
    status: 'out',
    unitPrice: 3000
  }
])

// Sample data: appointments
const appointments = ref([
  { date: '1404/08/01', time: '09:00', patientName: 'علی رضایی', doctorName: 'دکتر علی رضایی', operatorName: 'اپراتور 1', mobileNumber: '09120000001', status: 'scheduled', description: '' },
  { date: '1404/08/01', time: '10:30', patientName: 'فاطمه احمدی', doctorName: 'دکتر مریم حسینی', operatorName: 'اپراتور 2', mobileNumber: '09120000002', status: 'done', description: 'ویزیت' },
  { date: '1404/07/29', time: '12:00', patientName: 'حمید مرادی', doctorName: 'دکتر احمد محمدی', operatorName: 'اپراتور 1', mobileNumber: '09120000003', status: 'cancelled', description: 'لغو توسط بیمار' },
  { date: '1404/08/03', time: '11:15', patientName: 'سارا اکبری', doctorName: 'دکتر علی رضایی', operatorName: 'اپراتور 3', mobileNumber: '09120000004', status: 'no_show', description: 'عدم حضور' },
  { date: '1404/08/04', time: '09:30', patientName: 'زهرا محمدی', doctorName: 'دکتر مریم حسینی', operatorName: 'اپراتور 2', mobileNumber: '09120000005', status: 'scheduled', description: '' },
  { date: '1404/08/04', time: '12:15', patientName: 'سجاد کریمی', doctorName: 'دکتر احمد محمدی', operatorName: 'اپراتور 1', mobileNumber: '09120000006', status: 'done', description: 'ویزیت' },
  { date: '1404/08/05', time: '10:00', patientName: 'علی مرادی', doctorName: 'دکتر علی رضایی', operatorName: 'اپراتور 3', mobileNumber: '09120000007', status: 'cancelled', description: 'لغو توسط کلینیک' },
  { date: '1404/08/05', time: '13:30', patientName: 'حسن احمدی', doctorName: 'دکتر مریم حسینی', operatorName: 'اپراتور 2', mobileNumber: '09120000008', status: 'scheduled', description: '' },
  { date: '1404/08/06', time: '11:45', patientName: 'مریم رضایی', doctorName: 'دکتر احمد محمدی', operatorName: 'اپراتور 1', mobileNumber: '09120000009', status: 'no_show', description: '' },
  { date: '1404/08/06', time: '15:00', patientName: 'الهام اکبری', doctorName: 'دکتر علی رضایی', operatorName: 'اپراتور 3', mobileNumber: '09120000010', status: 'done', description: 'ویزیت' },
  { date: '1404/08/07', time: '09:00', patientName: 'فاطمه قاسمی', doctorName: 'دکتر مریم حسینی', operatorName: 'اپراتور 2', mobileNumber: '09120000011', status: 'scheduled', description: '' },
  { date: '1404/08/07', time: '10:30', patientName: 'محمد محمدی', doctorName: 'دکتر احمد محمدی', operatorName: 'اپراتور 1', mobileNumber: '09120000012', status: 'scheduled', description: '' },
  { date: '1404/08/07', time: '12:00', patientName: 'مینا حیدری', doctorName: 'دکتر علی رضایی', operatorName: 'اپراتور 3', mobileNumber: '09120000013', status: 'done', description: 'ویزیت' }
])

// Sample data: doctor/operator percentage rows
const percentRows = ref([
  { name: 'دکتر علی رضایی', role: 'doctor', count: 25, totalAmount: 7500000, percentage: 30 },
  { name: 'دکتر مریم حسینی', role: 'doctor', count: 18, totalAmount: 5400000, percentage: 25 },
  { name: 'اپراتور 1', role: 'operator', count: 40, totalAmount: 1200000, percentage: 10 },
  { name: 'اپراتور 2', role: 'operator', count: 22, totalAmount: 660000, percentage: 8 },
  { name: 'اپراتور 3', role: 'operator', count: 30, totalAmount: 900000, percentage: 9 },
  { name: 'اپراتور 4', role: 'operator', count: 18, totalAmount: 540000, percentage: 7 },
  { name: 'دکتر سارا موسوی', role: 'doctor', count: 12, totalAmount: 3600000, percentage: 20 },
  { name: 'دکتر رضا احمدی', role: 'doctor', count: 28, totalAmount: 8400000, percentage: 27 },
  { name: 'اپراتور 5', role: 'operator', count: 16, totalAmount: 480000, percentage: 6 },
  { name: 'دکتر نرگس کریمی', role: 'doctor', count: 19, totalAmount: 5700000, percentage: 23 },
  { name: 'اپراتور 6', role: 'operator', count: 25, totalAmount: 750000, percentage: 10 },
  { name: 'دکتر مهسا مرادی', role: 'doctor', count: 15, totalAmount: 4500000, percentage: 22 },
  { name: 'اپراتور 7', role: 'operator', count: 20, totalAmount: 600000, percentage: 8 }
])

// Sample data: SMS logs
const smsLogs = ref([
  { date: '1404/08/01', time: '08:00', to: '09120000001', name: 'علی رضایی', recipientType: 'patient', status: 'sent', message: 'یادآوری نوبت شما امروز ساعت 9:00' },
  { date: '1404/08/01', time: '08:10', to: '09120000002', name: 'فاطمه احمدی', recipientType: 'patient', status: 'failed', message: 'یادآوری نوبت شما امروز ساعت 10:30' },
  { date: '1404/08/02', time: '17:45', to: '09123334444', name: 'اپراتور 1', recipientType: 'operator', status: 'sent', message: 'گزارش روزانه آماده است.' },
  { date: '1404/08/03', time: '11:30', to: '09125556666', name: 'دکتر علی رضایی', recipientType: 'doctor', status: 'queued', message: 'جلسه امروز ساعت 12:30' },
  { date: '1404/08/03', time: '12:00', to: '09120000014', name: 'حسین محمدی', recipientType: 'patient', status: 'sent', message: 'یادآوری پرداخت' },
  { date: '1404/08/03', time: '12:10', to: '09120000015', name: 'مینا احمدی', recipientType: 'patient', status: 'failed', message: 'یادآوری نوبت' },
  { date: '1404/08/03', time: '12:20', to: '09120000016', name: 'اپراتور 2', recipientType: 'operator', status: 'sent', message: 'گزارش مالی ارسال شد' },
  { date: '1404/08/03', time: '12:30', to: '09120000017', name: 'دکتر رضا احمدی', recipientType: 'doctor', status: 'sent', message: 'جلسه فردا ساعت 9' },
  { date: '1404/08/03', time: '12:40', to: '09120000018', name: 'لیلا قاسمی', recipientType: 'patient', status: 'queued', message: 'نتیجه آزمایش آماده است' },
  { date: '1404/08/03', time: '12:50', to: '09120000019', name: 'ندا کریمی', recipientType: 'patient', status: 'sent', message: 'یادآوری مراجعه' },
  { date: '1404/08/03', time: '13:00', to: '09120000020', name: 'اپراتور 3', recipientType: 'operator', status: 'failed', message: 'بروزرسانی سیستم' },
  { date: '1404/08/03', time: '13:10', to: '09120000021', name: 'دکتر سارا موسوی', recipientType: 'doctor', status: 'sent', message: 'برنامه امروز' },
  { date: '1404/08/03', time: '13:20', to: '09120000022', name: 'رضا مرادی', recipientType: 'patient', status: 'sent', message: 'پیگیری وضعیت' }
])

// Computed properties
const filteredPatientPayments = computed(() => {
  return patientPayments.value.filter(payment => {
    // Filter by doctor name
    if (filters.value.doctorName && payment.doctorName !== filters.value.doctorName) {
      return false
    }
    
    // Filter by patient name
    if (filters.value.patientName && !payment.patientName.includes(filters.value.patientName)) {
      return false
    }
    
    // Filter by mobile number
    if (filters.value.mobileNumber && !payment.mobileNumber.includes(filters.value.mobileNumber)) {
      return false
    }
    
    // Filter by payment type
    if (filters.value.paymentType && payment.paymentType !== filters.value.paymentType) {
      return false
    }
    
    // Filter by file number
    if (filters.value.fileNumber && !payment.fileNumber.includes(filters.value.fileNumber)) {
      return false
    }
    
    // Filter by document number
    if (filters.value.documentNumber && !payment.documentNumber.includes(filters.value.documentNumber)) {
      return false
    }
    
    // Filter by referrer name
    if (filters.value.referrerName && !payment.referrerName.includes(filters.value.referrerName)) {
      return false
    }
    
    // Filter by purpose
    if (filters.value.purpose && !payment.purpose.includes(filters.value.purpose)) {
      return false
    }
    
    // Filter by intermediary
    if (filters.value.intermediary && !payment.intermediary.includes(filters.value.intermediary)) {
      return false
    }
    
    // Filter by description
    if (filters.value.description && !payment.description.includes(filters.value.description)) {
      return false
    }
    
    return true
  })
})

const totalFilteredPatientPayments = computed(() => {
  return filteredPatientPayments.value.reduce((sum, payment) => sum + (payment.totalAmount || payment.amount || 0), 0)
})

const totalPatientAmount = computed(() => {
  return filteredPatientPayments.value.reduce((sum, payment) => sum + (payment.patientAmount || 0), 0)
})

const doctorPercentage = computed(() => {
  // Assuming doctor gets a percentage of the total amount
  // You can adjust this calculation based on your business logic
  const total = totalFilteredPatientPayments.value
  if (total === 0) return 0
  const doctorShare = total * 0.3 // Example: 30% for doctor
  return Math.round((doctorShare / total) * 100)
})

// Paginated data for patient payments
const paginatedPatientPayments = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage
  const end = start + itemsPerPage
  return filteredPatientPayments.value.slice(start, end)
})

// Total pages for patient payments
const totalPages = computed(() => {
  return Math.ceil(filteredPatientPayments.value.length / itemsPerPage)
})

// Paginated data for unsettled bills
const paginatedUnsettledBills = computed(() => {
  const start = (currentUnsettledPage.value - 1) * unsettledItemsPerPage
  const end = start + unsettledItemsPerPage
  return filteredUnsettledBills.value.slice(start, end)
})

// Total pages for unsettled bills
const totalUnsettledPages = computed(() => {
  return Math.ceil(filteredUnsettledBills.value.length / unsettledItemsPerPage)
})

// Paginated data for bills and services
const paginatedBillsServices = computed(() => {
  const start = (currentBillsServicesPage.value - 1) * billsServicesItemsPerPage
  const end = start + billsServicesItemsPerPage
  return filteredBillsServices.value.slice(start, end)
})

// Total pages for bills and services
const totalBillsServicesPages = computed(() => {
  return Math.ceil(filteredBillsServices.value.length / billsServicesItemsPerPage)
})

// Paginated data for inventory
const paginatedInventory = computed(() => {
  const start = (currentInventoryPage.value - 1) * inventoryItemsPerPage
  const end = start + inventoryItemsPerPage
  return filteredInventory.value.slice(start, end)
})

// Total pages for inventory
const totalInventoryPages = computed(() => {
  return Math.ceil(filteredInventory.value.length / inventoryItemsPerPage)
})

// Paginated data for appointments
const paginatedAppointments = computed(() => {
  const start = (currentAppointmentsPage.value - 1) * appointmentsItemsPerPage
  const end = start + appointmentsItemsPerPage
  return filteredAppointments.value.slice(start, end)
})

// Total pages for appointments
const totalAppointmentsPages = computed(() => {
  return Math.ceil(filteredAppointments.value.length / appointmentsItemsPerPage)
})

// Paginated data for doctors/operators percentage
const paginatedPercentRows = computed(() => {
  const start = (currentPercentPage.value - 1) * percentItemsPerPage
  const end = start + percentItemsPerPage
  return filteredPercentRows.value.slice(start, end)
})

// Total pages for doctors/operators percentage
const totalPercentPages = computed(() => {
  return Math.ceil(filteredPercentRows.value.length / percentItemsPerPage)
})

// Paginated data for SMS report
const paginatedSmsLogs = computed(() => {
  const start = (currentSmsPage.value - 1) * smsItemsPerPage
  const end = start + smsItemsPerPage
  return filteredSmsLogs.value.slice(start, end)
})

// Total pages for SMS report
const totalSmsPages = computed(() => {
  return Math.ceil(filteredSmsLogs.value.length / smsItemsPerPage)
})

const filteredUnsettledBills = computed(() => {
  return unsettledBills.value.filter(bill => {
    // Filter by bill number range
    if (unsettledFilters.value.fromBillNumber && bill.invoiceNumber < unsettledFilters.value.fromBillNumber) {
      return false
    }
    if (unsettledFilters.value.toBillNumber && bill.invoiceNumber > unsettledFilters.value.toBillNumber) {
      return false
    }
    
    // Filter by doctor name
    if (unsettledFilters.value.doctorName && bill.doctorName !== unsettledFilters.value.doctorName) {
      return false
    }
    
    // Filter by patient name
    if (unsettledFilters.value.patientName && !bill.patientName.includes(unsettledFilters.value.patientName)) {
      return false
    }
    
    // Filter by file number
    if (unsettledFilters.value.fileNumber && !bill.fileNumber.includes(unsettledFilters.value.fileNumber)) {
      return false
    }
    
    // Filter by phone number
    if (unsettledFilters.value.phoneNumber && !bill.phoneNumber.includes(unsettledFilters.value.phoneNumber)) {
      return false
    }
    
    // Filter by mobile number
    if (unsettledFilters.value.mobileNumber && !bill.mobileNumber.includes(unsettledFilters.value.mobileNumber)) {
      return false
    }
    
    // Filter by intermediary
    if (unsettledFilters.value.intermediary && !bill.intermediary.includes(unsettledFilters.value.intermediary)) {
      return false
    }
    
    // Filter by created by
    if (unsettledFilters.value.createdBy && !bill.createdBy.includes(unsettledFilters.value.createdBy)) {
      return false
    }
    
    // Filter by valid/invalid bills
    if (!unsettledFilters.value.showValidBills && !bill.isCancelled) {
      return false
    }
    if (!unsettledFilters.value.showInvalidBills && bill.isCancelled) {
      return false
    }
    
    return true
  })
})

const totalUnsettledAmount = computed(() => {
  return filteredUnsettledBills.value.reduce((sum, bill) => sum + bill.amount, 0)
})

const totalRemainingAmount = computed(() => {
  return filteredUnsettledBills.value.reduce((sum, bill) => sum + (bill.remainingAmount || bill.amount), 0)
})

const totalPayableAmount = computed(() => {
  return filteredUnsettledBills.value.reduce((sum, bill) => sum + (bill.payableAmount || bill.amount), 0)
})

const filteredBillsServices = computed(() => {
  return billsServices.value.filter(service => {
    // Filter by bill number range
    if (billsServicesFilters.value.fromBillNumber && service.invoiceNumber < billsServicesFilters.value.fromBillNumber) {
      return false
    }
    if (billsServicesFilters.value.toBillNumber && service.invoiceNumber > billsServicesFilters.value.toBillNumber) {
      return false
    }
    
    // Filter by doctor name
    if (billsServicesFilters.value.doctorName && service.doctorName !== billsServicesFilters.value.doctorName) {
      return false
    }
    
    // Filter by patient name
    if (billsServicesFilters.value.patientName && !service.patientName.includes(billsServicesFilters.value.patientName)) {
      return false
    }
    
    // Filter by file number
    if (billsServicesFilters.value.fileNumber && !service.fileNumber.includes(billsServicesFilters.value.fileNumber)) {
      return false
    }
    
    // Filter by phone number
    if (billsServicesFilters.value.phoneNumber && !service.phoneNumber.includes(billsServicesFilters.value.phoneNumber)) {
      return false
    }
    
    // Filter by mobile number
    if (billsServicesFilters.value.mobileNumber && !service.mobileNumber.includes(billsServicesFilters.value.mobileNumber)) {
      return false
    }
    
    // Filter by created by
    if (billsServicesFilters.value.createdBy && !service.createdBy.includes(billsServicesFilters.value.createdBy)) {
      return false
    }
    
    // Filter by description
    if (billsServicesFilters.value.description && !service.description.includes(billsServicesFilters.value.description)) {
      return false
    }
    
    // Filter by service name
    if (billsServicesFilters.value.serviceName && !service.serviceName.includes(billsServicesFilters.value.serviceName)) {
      return false
    }
    
    // Filter by service code
    if (billsServicesFilters.value.serviceCode && !service.serviceCode.includes(billsServicesFilters.value.serviceCode)) {
      return false
    }
    
    // Filter by intermediary
    if (billsServicesFilters.value.intermediary && !service.intermediary.includes(billsServicesFilters.value.intermediary)) {
      return false
    }
    
    // Filter by valid/invalid bills
    if (!billsServicesFilters.value.showValidBills && !service.isCancelled) {
      return false
    }
    if (!billsServicesFilters.value.showInvalidBills && service.isCancelled) {
      return false
    }
    
    return true
  })
})

const totalFilteredBillsServices = computed(() => {
  return filteredBillsServices.value.reduce((sum, service) => sum + service.totalPrice, 0)
})

const uniqueBillsCount = computed(() => {
  const uniqueBills = new Set(filteredBillsServices.value.map(service => service.invoiceNumber))
  return uniqueBills.size
})

const totalInsuranceAmount = computed(() => {
  return filteredBillsServices.value.reduce((sum, service) => sum + (service.insuranceAmount || 0), 0)
})

const totalPatientShare = computed(() => {
  return filteredBillsServices.value.reduce((sum, service) => sum + (service.patientAmount || service.totalPrice * 0.7 || 0), 0)
})

const insurancePercentage = computed(() => {
  const total = totalFilteredBillsServices.value
  if (total === 0) return 0
  const insuranceShare = totalInsuranceAmount.value
  return Math.round((insuranceShare / total) * 100)
})

const totalBillsServices = computed(() => {
  return billsServices.value.reduce((sum, service) => sum + service.totalPrice, 0)
})

const filteredInventory = computed(() => {
  return inventory.value.filter(item => {
    // Filter by item name
    if (inventoryFilters.value.itemName && !item.name.includes(inventoryFilters.value.itemName)) {
      return false
    }
    
    return true
  })
})

const filteredAppointments = computed(() => {
  return appointments.value.map(a => ({
    ...a,
    statusText: a.status === 'scheduled' ? 'رزرو شده' : a.status === 'done' ? 'انجام شده' : a.status === 'cancelled' ? 'لغو شده' : 'عدم حضور'
  })).filter(a => {
    if (appointmentsFilters.value.doctorName && a.doctorName !== appointmentsFilters.value.doctorName) return false
    if (appointmentsFilters.value.operatorName && !a.operatorName.includes(appointmentsFilters.value.operatorName)) return false
    if (appointmentsFilters.value.patientName && !a.patientName.includes(appointmentsFilters.value.patientName)) return false
    if (appointmentsFilters.value.status && a.status !== appointmentsFilters.value.status) return false
    return true
  })
})

const upcomingAppointments = computed(() => {
  return filteredAppointments.value.filter(a => a.status === 'scheduled').length
})

const filteredPercentRows = computed(() => {
  return percentRows.value.map(r => ({
    ...r,
    roleText: r.role === 'doctor' ? 'پزشک' : 'اپراتور'
  })).filter(r => {
    if (percentFilters.value.role && r.role !== percentFilters.value.role) return false
    if (percentFilters.value.name && !r.name.includes(percentFilters.value.name)) return false
    return true
  })
})

const totalPercentAmount = computed(() => {
  return filteredPercentRows.value.reduce((s, r) => s + (r.totalAmount || 0), 0)
})

const filteredSmsLogs = computed(() => {
  return smsLogs.value.map(s => ({
    ...s,
    recipientText: s.recipientType === 'patient' ? 'بیمار' : s.recipientType === 'doctor' ? 'پزشک' : 'اپراتور',
    statusText: s.status === 'sent' ? 'ارسال شد' : s.status === 'failed' ? 'ناموفق' : 'در صف'
  })).filter(s => {
    if (smsFilters.value.status && s.status !== smsFilters.value.status) return false
    if (smsFilters.value.query && !(s.to.includes(smsFilters.value.query) || (s.name || '').includes(smsFilters.value.query))) return false
    if (smsFilters.value.messageText && !(s.message || '').includes(smsFilters.value.messageText)) return false
    return true
  })
})

const sentSmsCount = computed(() => filteredSmsLogs.value.filter(s => s.status === 'sent').length)
const failedSmsCount = computed(() => filteredSmsLogs.value.filter(s => s.status === 'failed').length)

const lowStockItems = computed(() => {
  return inventory.value.filter(item => item.status === 'low').length
})

const outOfStockItems = computed(() => {
  return inventory.value.filter(item => item.status === 'out').length
})

// Methods
const formatNumber = (number) => {
  return new Intl.NumberFormat('fa-IR').format(number)
}

const clearPatientPaymentsFilters = () => {
  filters.value.doctorName = ''
  filters.value.patientName = ''
  filters.value.phoneNumber = ''
  filters.value.mobileNumber = ''
  filters.value.paymentType = ''
  filters.value.fileNumber = ''
  filters.value.documentNumber = ''
  filters.value.referrerName = ''
  filters.value.purpose = ''
  filters.value.description = ''
  filters.value.intermediary = ''
  filters.value.showValidBills = true
  filters.value.showInvalidBills = false
  resetPagination()
}

const generatePatientPaymentsReport = () => {
  console.log('تولید گزارش پرداختی بیماران', filters.value)
  // Here you would typically make an API call with the filter parameters
}

// Show payment details modal
const showPaymentDetails = (payment) => {
  selectedPaymentDetails.value = payment
  showPaymentModal.value = true
}

// Close payment details modal
const closePaymentModal = () => {
  showPaymentModal.value = false
  selectedPaymentDetails.value = null
}

// Show unsettled bill details modal
const showUnsettledBillDetails = (bill) => {
  selectedUnsettledBillDetails.value = bill
  showUnsettledBillModal.value = true
}

// Close unsettled bill details modal
const closeUnsettledBillModal = () => {
  showUnsettledBillModal.value = false
  selectedUnsettledBillDetails.value = null
}

// Show bills-services details modal
const showBillsServicesDetails = (service) => {
  selectedBillsServicesDetails.value = service
  showBillsServicesModal.value = true
}

// Close bills-services details modal
const closeBillsServicesModal = () => {
  showBillsServicesModal.value = false
  selectedBillsServicesDetails.value = null
}

// Show percent details modal
const showPercentDetails = (row) => {
  selectedPercentDetails.value = row
  showPercentModal.value = true
}

// Close percent details modal
const closePercentModal = () => {
  showPercentModal.value = false
  selectedPercentDetails.value = null
}

// Show appointment details modal
const showAppointmentDetails = (appointment) => {
  selectedAppointmentDetails.value = appointment
  showAppointmentModal.value = true
}

// Close appointment details modal
const closeAppointmentModal = () => {
  showAppointmentModal.value = false
  selectedAppointmentDetails.value = null
}

// Show SMS details modal
const showSmsDetails = (sms) => {
  selectedSmsDetails.value = sms
  showSmsModal.value = true
}

// Close SMS details modal
const closeSmsModal = () => {
  showSmsModal.value = false
  selectedSmsDetails.value = null
}

// Show inventory details modal
const showInventoryDetails = (item) => {
  selectedInventoryDetails.value = item
  showInventoryModal.value = true
}

// Close inventory details modal
const closeInventoryModal = () => {
  showInventoryModal.value = false
  selectedInventoryDetails.value = null
}

// Pagination navigation functions
const goToPreviousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--
  }
}

const goToNextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++
  }
}

// Reset pagination when filters change
const resetPagination = () => {
  currentPage.value = 1
}

// Pagination navigation functions for unsettled bills
const goToPreviousUnsettledPage = () => {
  if (currentUnsettledPage.value > 1) {
    currentUnsettledPage.value--
  }
}

const goToNextUnsettledPage = () => {
  if (currentUnsettledPage.value < totalUnsettledPages.value) {
    currentUnsettledPage.value++
  }
}

// Pagination navigation functions for bills and services
const goToPreviousBillsServicesPage = () => {
  if (currentBillsServicesPage.value > 1) {
    currentBillsServicesPage.value--
  }
}

const goToNextBillsServicesPage = () => {
  if (currentBillsServicesPage.value < totalBillsServicesPages.value) {
    currentBillsServicesPage.value++
  }
}

// Pagination navigation functions for inventory
const goToPreviousInventoryPage = () => {
  if (currentInventoryPage.value > 1) {
    currentInventoryPage.value--
  }
}

const goToNextInventoryPage = () => {
  if (currentInventoryPage.value < totalInventoryPages.value) {
    currentInventoryPage.value++
  }
}

// Pagination navigation functions for appointments
const goToPreviousAppointmentsPage = () => {
  if (currentAppointmentsPage.value > 1) {
    currentAppointmentsPage.value--
  }
}

const goToNextAppointmentsPage = () => {
  if (currentAppointmentsPage.value < totalAppointmentsPages.value) {
    currentAppointmentsPage.value++
  }
}

// Pagination navigation functions for doctors/operators percentage
const goToPreviousPercentPage = () => {
  if (currentPercentPage.value > 1) {
    currentPercentPage.value--
  }
}

const goToNextPercentPage = () => {
  if (currentPercentPage.value < totalPercentPages.value) {
    currentPercentPage.value++
  }
}

// Pagination navigation functions for SMS report
const goToPreviousSmsPage = () => {
  if (currentSmsPage.value > 1) {
    currentSmsPage.value--
  }
}

const goToNextSmsPage = () => {
  if (currentSmsPage.value < totalSmsPages.value) {
    currentSmsPage.value++
  }
}

const exportToExcel = () => {
  console.log('خروجی اکسل گزارش پرداختی بیماران', filters.value)
  // Here you would implement Excel export functionality
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printReport = () => {
  console.log('چاپ گزارش پرداختی بیماران')
  
  // Create a new window for printing
  const printWindow = window.open('', '_blank')
  
  // Get the filtered data
  const filteredData = filteredPatientPayments.value
  
  // Create HTML content for printing
  const printContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش پرداختی بیماران</title>
      <style>
        body {
          font-family: 'Tahoma', 'Arial', sans-serif;
          direction: rtl;
          text-align: right;
          margin: 20px;
          font-size: 12px;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 10px;
        }
        .header h1 {
          margin: 0;
          color: #333;
        }
        .date-info {
          margin: 10px 0;
          color: #666;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #333;
          padding: 8px;
          text-align: center;
        }
        th {
          background-color: #f5f5f5;
          font-weight: bold;
        }
        .summary {
          margin-top: 20px;
          padding: 10px;
          background-color: #f9f9f9;
          border: 1px solid #333;
        }
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin: 5px 0;
        }
        @media print {
          body { margin: 0; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>گزارش پرداختی بیماران</h1>
        <div class="date-info">
          تاریخ گزارش: ${moment().format('jYYYY/jMM/jDD')}
        </div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>شماره قبض</th>
            <th>تاریخ قبض</th>
            <th>نام بیمار</th>
            <th>کد خدمات</th>
            <th>نام خدمات</th>
            <th>شماره پرونده</th>
            <th>نام پزشک</th>
            <th>تلفن بیمار</th>
            <th>تلفن همراه</th>
            <th>نام واسطه</th>
            <th>مبلغ سهم بیمه</th>
            <th>مبلغ سهم بیمار</th>
            <th>جمع کل</th>
            <th>توضیحات</th>
            <th>کاربر ثبت کننده</th>
            <th>تاریخ ثبت</th>
            <th>زمان ثبت</th>
            <th>درصد جمع کل</th>
          </tr>
        </thead>
        <tbody>
          ${filteredData.map((payment, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${payment.invoiceNumber || '-'}</td>
              <td>${payment.invoiceDate || payment.paymentDate || '-'}</td>
              <td>${payment.patientName}</td>
              <td>${payment.serviceCode || '-'}</td>
              <td>${payment.serviceName || payment.purpose || '-'}</td>
              <td>${payment.fileNumber}</td>
              <td>${payment.doctorName}</td>
              <td>${payment.phoneNumber || '-'}</td>
              <td>${payment.mobileNumber}</td>
              <td>${payment.intermediary || payment.referrerName || '-'}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(payment.insuranceAmount || 0)} ریال</td>
              <td>${new Intl.NumberFormat('fa-IR').format(payment.patientAmount || payment.amount || 0)} ریال</td>
              <td>${new Intl.NumberFormat('fa-IR').format(payment.totalAmount || payment.amount || 0)} ریال</td>
              <td>${payment.description || '-'}</td>
              <td>${payment.createdBy || 'سیستم'}</td>
              <td>${payment.createdDate || moment().format('jYYYY/jMM/jDD')}</td>
              <td>${payment.createdTime || moment().format('HH:mm:ss')}</td>
              <td>${payment.percentage || '100%'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="summary">
        <div class="summary-item">
          <span>تعداد پرداخت‌ها:</span>
          <span>${filteredData.length}</span>
        </div>
        <div class="summary-item">
          <span>درصد پزشک:</span>
          <span>${doctorPercentage.value}%</span>
        </div>
        <div class="summary-item">
          <span>جمع سهم بیمار:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalPatientAmount.value)} ریال</span>
        </div>
        <div class="summary-item">
          <span>مجموع مبلغ:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalFilteredPatientPayments.value)} ریال</span>
        </div>
      </div>
    </body>
    </html>
  `
  
  // Write content to the new window
  printWindow.document.write(printContent)
  printWindow.document.close()
  
  // Wait for content to load then print
  printWindow.onload = () => {
    printWindow.print()
    printWindow.close()
  }
}

const clearUnsettledBillsFilters = () => {
  unsettledFilters.value.fromBillNumber = ''
  unsettledFilters.value.toBillNumber = ''
  unsettledFilters.value.fromRegistrationDate = moment().subtract(30, 'days').format('jYYYY/jMM/jDD')
  unsettledFilters.value.toRegistrationDate = moment().format('jYYYY/jMM/jDD')
  unsettledFilters.value.doctorName = ''
  unsettledFilters.value.patientName = ''
  unsettledFilters.value.fileNumber = ''
  unsettledFilters.value.phoneNumber = ''
  unsettledFilters.value.mobileNumber = ''
  unsettledFilters.value.intermediary = ''
  unsettledFilters.value.createdBy = ''
  unsettledFilters.value.showValidBills = true
  unsettledFilters.value.showInvalidBills = false
  currentUnsettledPage.value = 1
}

const generateUnsettledBillsReport = () => {
  console.log('تولید گزارش قبض های تسویه نشده', unsettledFilters.value)
  // Here you would typically make an API call with the filter parameters
}

const exportUnsettledBillsToExcel = () => {
  console.log('خروجی اکسل گزارش قبض های تسویه نشده', unsettledFilters.value)
  // Here you would implement Excel export functionality
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printUnsettledBillsReport = () => {
  console.log('چاپ گزارش قبض های تسویه نشده')
  
  // Create a new window for printing
  const printWindow = window.open('', '_blank')
  
  // Get the filtered data
  const filteredData = filteredUnsettledBills.value
  
  // Create HTML content for printing
  const printContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش قبض های تسویه نشده</title>
      <style>
        body {
          font-family: 'Tahoma', 'Arial', sans-serif;
          direction: rtl;
          text-align: right;
          margin: 20px;
          font-size: 12px;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 10px;
        }
        .header h1 {
          margin: 0;
          color: #333;
        }
        .date-info {
          margin: 10px 0;
          color: #666;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #333;
          padding: 8px;
          text-align: center;
        }
        th {
          background-color: #f5f5f5;
          font-weight: bold;
        }
        .summary {
          margin-top: 20px;
          padding: 10px;
          background-color: #f9f9f9;
          border: 1px solid #333;
        }
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin: 5px 0;
        }
        @media print {
          body { margin: 0; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>گزارش قبض های تسویه نشده</h1>
        <div class="date-info">
          تاریخ گزارش: ${moment().format('jYYYY/jMM/jDD')}
        </div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>شماره قبض</th>
            <th>تاریخ قبض</th>
            <th>نام بیمار</th>
            <th>مانده قبض</th>
            <th>جمع قابل پرداخت</th>
            <th>شماره پرونده</th>
            <th>تلفن بیمار</th>
            <th>تلفن همراه</th>
            <th>نام واسطه</th>
            <th>مبلغ سهم بیمه</th>
            <th>مبلغ سهم بیمار</th>
            <th>جمع کل</th>
            <th>کاربر ثبت کننده</th>
            <th>تاریخ ثبت</th>
            <th>زمان ثبت</th>
          </tr>
        </thead>
        <tbody>
          ${filteredData.map((bill, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${bill.invoiceNumber}</td>
              <td>${bill.invoiceDate || bill.issueDate}</td>
              <td>${bill.patientName}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(bill.remainingAmount || bill.amount)} ریال</td>
              <td>${new Intl.NumberFormat('fa-IR').format(bill.payableAmount || bill.amount)} ریال</td>
              <td>${bill.fileNumber}</td>
              <td>${bill.phoneNumber}</td>
              <td>${bill.mobileNumber}</td>
              <td>${bill.intermediary}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(bill.insuranceAmount || 0)} ریال</td>
              <td>${new Intl.NumberFormat('fa-IR').format(bill.patientAmount || bill.amount)} ریال</td>
              <td>${new Intl.NumberFormat('fa-IR').format(bill.totalAmount || bill.amount)} ریال</td>
              <td>${bill.createdBy}</td>
              <td>${bill.createdDate}</td>
              <td>${bill.createdTime}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="summary">
        <div class="summary-item">
          <span>تعداد قبض‌های تسویه نشده:</span>
          <span>${filteredData.length}</span>
        </div>
        <div class="summary-item">
          <span>جمع مانده ها:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalRemainingAmount.value)} ریال</span>
        </div>
        <div class="summary-item">
          <span>جمع کل قابل پرداخت:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalPayableAmount.value)} ریال</span>
        </div>
      </div>
    </body>
    </html>
  `
  
  // Write content to the new window
  printWindow.document.write(printContent)
  printWindow.document.close()
  
  // Wait for content to load then print
  printWindow.onload = () => {
    printWindow.print()
    printWindow.close()
  }
}

const clearBillsServicesFilters = () => {
  billsServicesFilters.value.fromBillNumber = ''
  billsServicesFilters.value.toBillNumber = ''
  billsServicesFilters.value.fromDate = moment().subtract(30, 'days').format('jYYYY/jMM/jDD')
  billsServicesFilters.value.toDate = moment().format('jYYYY/jMM/jDD')
  billsServicesFilters.value.fromRegistrationDate = moment().subtract(30, 'days').format('jYYYY/jMM/jDD')
  billsServicesFilters.value.toRegistrationDate = moment().format('jYYYY/jMM/jDD')
  billsServicesFilters.value.doctorName = ''
  billsServicesFilters.value.patientName = ''
  billsServicesFilters.value.fileNumber = ''
  billsServicesFilters.value.phoneNumber = ''
  billsServicesFilters.value.mobileNumber = ''
  billsServicesFilters.value.createdBy = ''
  billsServicesFilters.value.description = ''
  billsServicesFilters.value.serviceName = ''
  billsServicesFilters.value.serviceCode = ''
  billsServicesFilters.value.intermediary = ''
  billsServicesFilters.value.showValidBills = true
  billsServicesFilters.value.showInvalidBills = false
  currentBillsServicesPage.value = 1
}

const generateBillsServicesReport = () => {
  console.log('تولید گزارش قبض ها و خدمات', billsServicesFilters.value)
  // Here you would typically make an API call with the filter parameters
}

const exportBillsServicesToExcel = () => {
  console.log('خروجی اکسل گزارش قبض ها و خدمات', billsServicesFilters.value)
  // Here you would implement Excel export functionality
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printBillsServicesReport = () => {
  console.log('چاپ گزارش قبض ها و خدمات')
  
  // Create a new window for printing
  const printWindow = window.open('', '_blank')
  
  // Get the filtered data
  const filteredData = filteredBillsServices.value
  
  // Create HTML content for printing
  const printContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش از قبض ها و خدمات</title>
      <style>
        body {
          font-family: 'Tahoma', 'Arial', sans-serif;
          direction: rtl;
          text-align: right;
          margin: 20px;
          font-size: 12px;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 10px;
        }
        .header h1 {
          margin: 0;
          color: #333;
        }
        .date-info {
          margin: 10px 0;
          color: #666;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #333;
          padding: 8px;
          text-align: center;
        }
        th {
          background-color: #f5f5f5;
          font-weight: bold;
        }
        .summary {
          margin-top: 20px;
          padding: 10px;
          background-color: #f9f9f9;
          border: 1px solid #333;
        }
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin: 5px 0;
        }
        @media print {
          body { margin: 0; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>گزارش از قبض ها و خدمات</h1>
        <div class="date-info">
          تاریخ گزارش: ${moment().format('jYYYY/jMM/jDD')}
        </div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>شماره قبض</th>
            <th>تاریخ قبض</th>
            <th>نام بیمار</th>
            <th>نام پزشک</th>
            <th>شماره پرونده</th>
            <th>تلفن بیمار</th>
            <th>تلفن همراه</th>
            <th>کاربر ثبت کننده</th>
            <th>توضیحات</th>
            <th>نام خدمات</th>
            <th>کد خدمات</th>
            <th>واسطه</th>
            <th>مبلغ واحد</th>
            <th>تعداد</th>
            <th>جمع کل</th>
            <th>تاریخ ثبت</th>
            <th>زمان ثبت</th>
          </tr>
        </thead>
        <tbody>
          ${filteredData.map((service, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${service.invoiceNumber}</td>
              <td>${service.invoiceDate || service.date}</td>
              <td>${service.patientName}</td>
              <td>${service.doctorName}</td>
              <td>${service.fileNumber}</td>
              <td>${service.phoneNumber || '-'}</td>
              <td>${service.mobileNumber || '-'}</td>
              <td>${service.createdBy || 'سیستم'}</td>
              <td>${service.description || '-'}</td>
              <td>${service.serviceName}</td>
              <td>${service.serviceCode || '-'}</td>
              <td>${service.intermediary || '-'}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(service.unitPrice)} ریال</td>
              <td>${service.quantity}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(service.totalPrice)} ریال</td>
              <td>${service.createdDate || moment().format('jYYYY/jMM/jDD')}</td>
              <td>${service.createdTime || moment().format('HH:mm:ss')}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="summary">
        <div class="summary-item">
          <span>تعداد پرداخت‌ها:</span>
          <span>${filteredData.length}</span>
        </div>
        <div class="summary-item">
          <span>جمع سهم بیمه:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalInsuranceAmount.value)} ریال</span>
        </div>
        <div class="summary-item">
          <span>جمع سهم بیمار:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalPatientShare.value)} ریال</span>
        </div>
        <div class="summary-item">
          <span>درصد:</span>
          <span>${insurancePercentage.value}%</span>
        </div>
        <div class="summary-item">
          <span>جمع کل:</span>
          <span>${new Intl.NumberFormat('fa-IR').format(totalFilteredBillsServices.value)} ریال</span>
        </div>
      </div>
    </body>
    </html>
  `
  
  // Write content to the new window
  printWindow.document.write(printContent)
  printWindow.document.close()
  
  // Wait for content to load then print
  printWindow.onload = () => {
    printWindow.print()
    printWindow.close()
  }
}

const clearInventoryFilters = () => {
  inventoryFilters.value.fromDate = moment().subtract(30, 'days').format('jYYYY/jMM/jDD')
  inventoryFilters.value.toDate = moment().format('jYYYY/jMM/jDD')
  inventoryFilters.value.itemName = ''
  currentInventoryPage.value = 1
}

const generateInventoryReport = () => {
  console.log('تولید گزارش موجودی کالا', inventoryFilters.value)
  // Here you would typically make an API call with the filter parameters
}

const exportInventoryToExcel = () => {
  console.log('خروجی اکسل گزارش موجودی کالا', inventoryFilters.value)
  // Here you would implement Excel export functionality
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printInventoryReport = () => {
  console.log('چاپ گزارش موجودی کالا')
  
  // Create a new window for printing
  const printWindow = window.open('', '_blank')
  
  // Get the filtered data
  const filteredData = filteredInventory.value
  
  // Create HTML content for printing
  const printContent = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش موجودی کالا</title>
      <style>
        body {
          font-family: 'Tahoma', 'Arial', sans-serif;
          direction: rtl;
          text-align: right;
          margin: 20px;
          font-size: 12px;
        }
        .header {
          text-align: center;
          margin-bottom: 30px;
          border-bottom: 2px solid #333;
          padding-bottom: 10px;
        }
        .header h1 {
          margin: 0;
          color: #333;
        }
        .date-info {
          margin: 10px 0;
          color: #666;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
        }
        th, td {
          border: 1px solid #333;
          padding: 8px;
          text-align: center;
        }
        th {
          background-color: #f5f5f5;
          font-weight: bold;
        }
        .summary {
          margin-top: 20px;
          padding: 10px;
          background-color: #f9f9f9;
          border: 1px solid #333;
        }
        .summary-item {
          display: flex;
          justify-content: space-between;
          margin: 5px 0;
        }
        @media print {
          body { margin: 0; }
          .no-print { display: none; }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>گزارش موجودی کالا</h1>
        <div class="date-info">
          تاریخ گزارش: ${moment().format('jYYYY/jMM/jDD')}
        </div>
      </div>
      
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>نام کالا</th>
            <th>کد کالا</th>
            <th>موجودی فعلی</th>
            <th>حداقل موجودی</th>
            <th>وضعیت</th>
            <th>قیمت واحد</th>
          </tr>
        </thead>
        <tbody>
          ${filteredData.map((item, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${item.name}</td>
              <td>${item.code}</td>
              <td>${item.currentStock}</td>
              <td>${item.minStock}</td>
              <td>${item.status === 'low' ? 'کم' : item.status === 'out' ? 'تمام' : 'کافی'}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(item.unitPrice)} ریال</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      
      <div class="summary">
        <div class="summary-item">
          <span>تعداد کالاها:</span>
          <span>${filteredData.length}</span>
        </div>
        <div class="summary-item">
          <span>کالاهای کم موجود:</span>
          <span>${lowStockItems.value}</span>
        </div>
        <div class="summary-item">
          <span>کالاهای تمام شده:</span>
          <span>${outOfStockItems.value}</span>
        </div>
      </div>
    </body>
    </html>
  `
  
  // Write content to the new window
  printWindow.document.write(printContent)
  printWindow.document.close()
  
  // Wait for content to load then print
  printWindow.onload = () => {
    printWindow.print()
    printWindow.close()
  }
}

// Appointments actions
const clearAppointmentsFilters = () => {
  appointmentsFilters.value.doctorName = ''
  appointmentsFilters.value.operatorName = ''
  appointmentsFilters.value.patientName = ''
  appointmentsFilters.value.status = ''
  currentAppointmentsPage.value = 1
}

const generateAppointmentsReport = () => {
  console.log('تولید گزارش لیست نوبت ها', appointmentsFilters.value)
}

const exportAppointmentsToExcel = () => {
  console.log('خروجی اکسل گزارش لیست نوبت ها', appointmentsFilters.value)
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printAppointmentsReport = () => {
  const printWindow = window.open('', '_blank')
  const data = filteredAppointments.value
  const html = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش لیست نوبت ها</title>
      <style>
        body { font-family: 'Tahoma','Arial',sans-serif; direction: rtl; text-align: right; margin: 20px; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #333; padding: 8px; text-align: center; }
        th { background: #f5f5f5; font-weight: bold; }
      </style>
    </head>
    <body>
      <h1 style="text-align:center;">گزارش لیست نوبت ها</h1>
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>تاریخ</th>
            <th>ساعت</th>
            <th>بیمار</th>
            <th>پزشک</th>
            <th>اپراتور</th>
            <th>تلفن همراه</th>
            <th>وضعیت</th>
            <th>توضیحات</th>
          </tr>
        </thead>
        <tbody>
          ${data.map((item, i) => `
            <tr>
              <td>${i + 1}</td>
              <td>${item.date}</td>
              <td>${item.time}</td>
              <td>${item.patientName}</td>
              <td>${item.doctorName}</td>
              <td>${item.operatorName || '-'}</td>
              <td>${item.mobileNumber || '-'}</td>
              <td>${item.statusText}</td>
              <td>${item.description || '-'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </body>
    </html>
  `
  printWindow.document.write(html)
  printWindow.document.close()
  printWindow.onload = () => { printWindow.print(); printWindow.close() }
}

// Percent actions
const clearPercentFilters = () => {
  percentFilters.value.role = ''
  percentFilters.value.name = ''
  currentPercentPage.value = 1
}

const generatePercentReport = () => {
  console.log('تولید گزارش درصد پزشکان/اپراتورها', percentFilters.value)
}

const exportPercentToExcel = () => {
  console.log('خروجی اکسل گزارش درصد پزشکان/اپراتورها', percentFilters.value)
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printPercentReport = () => {
  const printWindow = window.open('', '_blank')
  const data = filteredPercentRows.value
  const html = `
    <!DOCTYPE html>
    <html dir="rtl" lang="fa">
    <head>
      <meta charset="UTF-8">
      <title>گزارش درصد پزشکان/اپراتورها</title>
      <style>
        body { font-family: 'Tahoma','Arial',sans-serif; direction: rtl; text-align: right; margin: 20px; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #333; padding: 8px; text-align: center; }
        th { background: #f5f5f5; font-weight: bold; }
      </style>
    </head>
    <body>
      <h1 style="text-align:center;">گزارش درصد پزشکان/اپراتورها</h1>
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>نام</th>
            <th>نقش</th>
            <th>تعداد خدمات/نوبت</th>
            <th>مبلغ کل</th>
            <th>درصد</th>
          </tr>
        </thead>
        <tbody>
          ${data.map((row, i) => `
            <tr>
              <td>${i + 1}</td>
              <td>${row.name}</td>
              <td>${row.role === 'doctor' ? 'پزشک' : 'اپراتور'}</td>
              <td>${row.count}</td>
              <td>${new Intl.NumberFormat('fa-IR').format(row.totalAmount)} ریال</td>
              <td>${row.percentage}%</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </body>
    </html>
  `
  printWindow.document.write(html)
  printWindow.document.close()
  printWindow.onload = () => { printWindow.print(); printWindow.close() }
}

// SMS actions
const clearSmsFilters = () => {
  smsFilters.value.status = ''
  smsFilters.value.query = ''
  smsFilters.value.messageText = ''
  currentSmsPage.value = 1
}

const generateSmsReport = () => {
  console.log('تولید گزارش ارسال پیامک', smsFilters.value)
}

const exportSmsToExcel = () => {
  console.log('خروجی اکسل گزارش ارسال پیامک', smsFilters.value)
  alert('خروجی اکسل در حال آماده‌سازی است...')
}

const printSmsReport = () => {
  const printWindow = window.open('', '_blank')
  const data = filteredSmsLogs.value
  const html = `
    <!DOCTYPE html>
    <html dir="rtl" lang="فا">
    <head>
      <meta charset="UTF-8">
      <title>گزارش ارسال پیامک</title>
      <style>
        body { font-family: 'Tahoma','Arial',sans-serif; direction: rtl; text-align: right; margin: 20px; font-size: 12px; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #333; padding: 8px; text-align: center; }
        th { background: #f5f5f5; font-weight: bold; }
      </style>
    </head>
    <body>
      <h1 style="text-align:center;">گزارش ارسال پیامک</h1>
      <table>
        <thead>
          <tr>
            <th>ردیف</th>
            <th>تاریخ</th>
            <th>ساعت</th>
            <th>گیرنده</th>
            <th>نام</th>
            <th>نوع گیرنده</th>
            <th>وضعیت</th>
            <th>متن پیام</th>
          </tr>
        </thead>
        <tbody>
          ${data.map((sms, i) => `
            <tr>
              <td>${i + 1}</td>
              <td>${sms.date}</td>
              <td>${sms.time}</td>
              <td>${sms.to}</td>
              <td>${sms.name || '-'}</td>
              <td>${sms.recipientType === 'patient' ? 'بیمار' : sms.recipientType === 'doctor' ? 'پزشک' : 'اپراتور'}</td>
              <td>${sms.status === 'sent' ? 'ارسال شد' : sms.status === 'failed' ? 'ناموفق' : 'در صف'}</td>
              <td>${sms.message}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
    </body>
    </html>
  `
  printWindow.document.write(html)
  printWindow.document.close()
  printWindow.onload = () => { printWindow.print(); printWindow.close() }
}

// Carousel functionality
const tabsContainer = ref(null)
const scrollPosition = ref(0)
const isScrollAtEnd = ref(false)

const scrollTabs = (direction) => {
  if (!tabsContainer.value) return
  
  const container = tabsContainer.value
  const scrollAmount = 200
  
  if (direction === 'left') {
    container.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    })
  } else {
    container.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    })
  }
  
  // Update state after scroll
  setTimeout(() => {
    updateScrollState()
  }, 200)
}

const updateScrollState = () => {
  if (!tabsContainer.value) return
  
  const container = tabsContainer.value
  const currentScroll = container.scrollLeft
  const maxScroll = container.scrollWidth - container.clientWidth
  
  scrollPosition.value = currentScroll
  isScrollAtEnd.value = currentScroll >= maxScroll - 5 // 5px tolerance
}

const handleScroll = () => {
  updateScrollState()
}

// Lifecycle
onMounted(() => {
  // Initialize any required data
  if (tabsContainer.value) {
    tabsContainer.value.addEventListener('scroll', handleScroll)
    updateScrollState()
  }
  
  // Also check on window resize
  window.addEventListener('resize', () => {
    setTimeout(() => {
      updateScrollState()
    }, 100)
  })
})
</script>

<style scoped>
:root {
  --text-color-secondary: #6b7280;
  --text-color-secondary-rgb: 107, 114, 128;
  --background-color-button-rgb: 20, 116, 242;
}

.reports-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
}

/* space below page header */
.reports-container > .header {
  margin-bottom: 20px;
}


/* تب‌ها */
.reports-tabs-container {
  margin-bottom: 20px;
  border-bottom: 2px solid var(--text-color-secondary);
}

.tabs-carousel-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
}

.reports-tabs {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  gap: 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
}

.reports-tabs::-webkit-scrollbar {
  display: none;
}

.tab-button {
  padding: 12px 20px;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  font-size: 14px;
  font-weight: 500;
  color: var(--text-color-secondary);
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  flex-shrink: 0;
}

.tab-button:hover {
  color: var(--background-color-button);
  background-color: var(--background-color-secondary);
}

.tab-button.active {
  color: var(--background-color-button);
  border-bottom-color: var(--background-color-button);
  background-color: var(--background-color-secondary);
}

/* Carousel navigation buttons */
.carousel-nav-btn {
  background: var(--background-color-secondary);
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  z-index: 10;
}

.carousel-nav-btn:hover:not(:disabled) {
  background: var(--background-color);
  border-color: var(--background-color-button);
}

.carousel-nav-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.carousel-nav-btn svg {
  width: 16px;
  height: 16px;
  fill: var(--text-color-primary);
  transition: fill 0.3s ease;
  transform: rotate(180deg);
}

.carousel-nav-btn:hover:not(:disabled) svg {
  fill: var(--background-color-button);
}

.carousel-nav-btn .carousel-icon {
  width: 16px;
  height: 16px;
  transition: filter 0.3s ease;
}

body.dark-theme .carousel-nav-btn .carousel-icon {
  filter: invert(1);
}

.carousel-nav-btn:hover:not(:disabled) .carousel-icon {
  filter: brightness(0) saturate(100%) invert(36%) sepia(93%) saturate(1815%) hue-rotate(203deg) brightness(95%) contrast(92%);
}

.carousel-prev {
  margin-left: 10px;
}

.carousel-next {
  margin-right: 10px;
}

.tab-content {
  background: var(--background-color);
  border: 1px solid var(--text-color-secondary);
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 4px rgba(var(--text-color-secondary-rgb), 0.1);
}

/* هدر گزارش */
.report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--text-color-secondary);
}

.report-header h3 {
  margin: 0;
  color: var(--text-color-primary);
}

.report-filters {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
  align-items: end;
}

.filter-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  gap: 20px;
}

.actions-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.report-info {
  display: flex;
  gap: 20px;
  align-items: center;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-align: center;
}

.info-item label {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

.info-item span {
  font-size: 14px;
  color: #343a40;
  font-weight: 600;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.filter-group label {
  font-size: 12px;
  font-weight: 600;
  color: #495057;
}

/* محتوای گزارش */
.report-content {
  margin-top: 20px;
}

.report-table {
  overflow-x: auto;
  margin-bottom: 20px;
}

.report-table table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--border-color);
  border-radius: 6px;
  overflow: hidden;
}

.report-table th,
.report-table td {
  padding: 12px;
  text-align: right;
  border-bottom: 1px solid var(--text-color-secondary);
}

.report-table td {
  font-size: 12px;
  color: var(--text-color-primary);
}

.report-table th {
  background-color: var(--background-color-secondary);
  font-weight: 600;
  color: var(--text-color-primary);
  font-size: 12px;
}

.report-table tr:hover {
  background-color: var(--background-color-secondary);
}

/* خلاصه گزارش */
.report-summary {
  display: flex;
  gap: 30px;
  padding: 15px;
  background-color: var(--background-color-secondary);
  border-radius: 6px;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.summary-item span:first-child {
  font-size: 12px;
  color: var(--text-color-secondary);
  font-weight: 500;
}

.summary-item span:last-child {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color-primary);
}

/* وضعیت */
.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.sufficient {
  background-color: #d4edda;
  color: #155724;
}

.status-badge.low {
  background-color: #fff3cd;
  color: #856404;
}

.status-badge.out {
  background-color: #f8d7da;
  color: #721c24;
}

.status-badge.unsettled {
  background-color: #f8d7da;
  color: #721c24;
}

/* فرم */
.form-input,
.form-select {
  padding: 8px 10px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 6px;
  font-size: 14px;
  text-align: right;
  direction: rtl;
  background: var(--background-color);
  color: var(--text-color-primary);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select {
  background: var(--background-color);
  cursor: pointer;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--background-color-button);
  box-shadow: 0 0 0 0.2rem rgba(var(--background-color-button-rgb), 0.25);
}

/* چک باکس‌ها */
.checkbox-group {
  grid-column: span 2;
}

.checkbox-container {
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-top: 5px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-size: 14px;
}

.checkbox-label.white {
  background-color: var(--background-color);
  border: 1px solid var(--text-color-secondary);
}

.checkbox-label.white:hover {
  background-color: var(--background-color-secondary);
}

.checkbox-label.pink {
  background-color: #fce4ec;
  border: 1px solid #f8bbd9;
}

.checkbox-label.pink:hover {
  background-color: #f8bbd9;
}

.checkbox-input {
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.checkbox-text {
  font-weight: 500;
  color: #495057;
}

.checkbox-label.white .checkbox-text {
  color: #495057;
}

.checkbox-label.pink .checkbox-text {
  color: #721c24;
}

/* دکمه */
.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-primary:hover {
  background-color: var(--background-color-button-hover);
}

/* Date picker */
.p-date {
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: start;
  overflow: hidden;
  background-color: var(--background-color);
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.p-date :deep(.vpd-container) {
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  background-color: var(--background-color);
}

.p-date :deep(.vpd-input-group label) {
  background-color: var(--background-color-button) !important;
}

.p-date :deep(.vpd-input-group input) {
  border: none !important;
  line-height: 32px !important;
  background-color: var(--background-color) !important;
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-input-group input::placeholder) {
  color: var(--text-color-secondary) !important;
  opacity: 1;
}

.p-date :deep(.vpd-input-group input:focus) {
  border: 1px solid transparent !important;
}

.p-date :deep(.vpd-icon-btn),
.p-date :deep(button.vpd-icon-btn),
.p-date :deep(.vpd-actions button) {
  background-color: var(--background-color-button) !important;
  color: var(--background-color) !important;
  transition: background-color 0.3s ease !important;
}

.p-date :deep(.vpd-icon-btn svg),
.p-date :deep(button.vpd-icon-btn svg),
.p-date :deep(.vpd-actions button svg),
.p-date :deep(.vpd-icon-btn svg path),
.p-date :deep(button.vpd-icon-btn svg path),
.p-date :deep(.vpd-actions button svg path) {
  fill: var(--background-color) !important;
  color: var(--background-color) !important;
  stroke: var(--background-color) !important;
}

.p-date :deep(.vpd-icon-btn:hover),
.p-date :deep(button.vpd-icon-btn:hover),
.p-date :deep(.vpd-actions button:hover) {
  background-color: var(--background-color-button-hover) !important;
}

.p-date :deep(.vpd-addon-list) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

.p-date :deep(.vpd-addon-list-item) {
  color: var(--text-color-primary) !important;
}

.p-date :deep(.vpd-addon-list-item:hover) {
  background: var(--background-color-secondary) !important;
}

.p-date :deep(.vpd-picker-container) {
  background: var(--background-color) !important;
  border: 1px solid var(--text-color-secondary) !important;
}

/* Responsive */
@media (max-width: 1200px) {
  .filters-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 992px) {
  .filters-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .report-header {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .filters-grid {
    display: block;
  }
  
  .checkbox-container {
    flex-direction: column;
    gap: 10px;
  }
  
  .filter-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .actions-buttons {
    justify-content: center;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 10px;
    width: 100%;
  }
  
  .actions-buttons button {
    width: 100%;
    height: 100%;
    min-width: 0;
    min-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  
  .report-info {
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .report-summary {
    justify-content: center;
  }
  
  .tabs-carousel-wrapper {
    gap: 5px;
  }
  
  .carousel-nav-btn {
    width: 35px;
    height: 35px;
  }
  
  .carousel-nav-btn svg {
    width: 14px;
    height: 14px;
  }
  
  .carousel-nav-btn .carousel-icon {
    width: 14px;
    height: 14px;
  }
  
  .tab-button {
    font-size: 12px;
    padding: 10px 15px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .report-table {
    overflow-x: auto;
  }
  
  .report-table table {
    min-width: 800px;
  }
}

/* Extra small screens */
@media (max-width: 480px) {
  .tabs-carousel-wrapper {
    gap: 3px;
  }
  
  .carousel-nav-btn {
    width: 30px;
    height: 30px;
  }
  
  .carousel-nav-btn svg {
    width: 12px;
    height: 12px;
  }
  
  .carousel-nav-btn .carousel-icon {
    width: 12px;
    height: 12px;
  }
  
  .carousel-prev {
    margin-left: 5px;
  }
  
  .carousel-next {
    margin-right: 5px;
  }
  
  .tab-button {
    font-size: 11px;
    padding: 8px 12px;
  }
}

/* Mobile dropdown styles for patient payments filters */
.mobile-more-filters {
  display: none;
}

.more-filters-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px 15px;
  background: var(--background-color-secondary);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  color: var(--text-color-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.more-filters-btn:hover {
  background: var(--background-color-secondary);
  border-color: var(--text-color-primary);
  color: var(--text-color-primary);
}

.arrow-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}

.arrow-icon.rotated {
  transform: rotate(180deg);
}

.additional-filters {
  display: contents;
}

/* Mobile responsive styles */
@media (max-width: 768px) {
  .mobile-more-filters {
    display: block;
    grid-column: 1 / -1;
    margin-top: 10px;
  }
  
  .additional-filters {
    display: none;
    grid-column: 1 / -1;
    margin-top: 15px;
    padding: 15px;
    background: var(--background-color-secondary);
    border-radius: 6px;
    border: 1px solid var(--border-color);
  }
  
  .additional-filters.show {
    display: grid;
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .filters-grid {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
  
  .filter-group {
    grid-column: 1 / -1;
  }
  
  /* Keep date fields in a row on mobile - target the first two filter groups */
  .filter-group:nth-child(1),
  .filter-group:nth-child(2) {
    grid-column: span 1;
  }
}

@media (max-width: 480px) {
  .filters-grid {
    grid-template-columns: 1fr;
  }
  
  .filter-group:nth-child(1),
  .filter-group:nth-child(2) {
    grid-column: 1 / -1;
  }
  
  .additional-filters.show {
    grid-template-columns: 1fr;
  }
  
  .actions-buttons {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 8px;
  }
}

/* Mobile table styles */
.desktop-table {
  display: block;
}

.mobile-table {
  display: none;
}

@media (max-width: 768px) {
  .desktop-table {
    display: none;
  }
  
  .sms-desktop-table {
    display: none;
  }
  
  .mobile-table {
    display: block;
  }
  
  .mobile-table-row {
    background: var(--background-color);
    border: 1px solid var(--border-color);
    border-radius: 8px;
    margin-bottom: 10px;
    padding: 15px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .mobile-row-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 15px;
  }
  
  .mobile-row-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .mobile-info-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  
  .mobile-label {
    font-size: 12px;
    color: #6c757d;
    font-weight: 500;
  }
  
  .mobile-value {
    font-size: 14px;
    color: #343a40;
    font-weight: 600;
  }
  
  .mobile-view-btn {
    background: var(--background-color-button);
    color: var(--text-color-primary);
    border: none;
    border-radius: 6px;
    padding: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    flex-shrink: 0;
  }
  
  .mobile-view-btn:hover {
    background: rgba(var(--background-color-button-rgb), 0.8);
    transform: scale(1.05);
  }
  
  .mobile-view-btn svg {
    width: 16px;
    height: 16px;
  }
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: var(--background-color);
  border-radius: 8px;
  max-width: 500px;
  width: 100%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h3 {
  margin: 0;
  color: #343a40;
  font-size: 18px;
}

.modal-close-btn {
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  background: #f8f9fa;
  color: #343a40;
}

.modal-body {
  padding: 20px;
}

.payment-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f8f9fa;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  flex: 1;
}

.detail-value {
  font-size: 14px;
  color: #343a40;
  font-weight: 600;
  text-align: left;
  flex: 1;
}

/* Scroll Indicator Styles */
.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  margin-top: 10px;
  border-top: 1px solid #e9ecef;
  background: linear-gradient(to bottom, rgba(255,255,255,0.8), rgba(255,255,255,1));
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.scroll-arrow {
  animation: bounce 2s infinite;
  margin-bottom: 5px;
}

.arrow-down {
  font-size: 24px;
  color: var(--text-color-primary);
  font-weight: bold;
  display: inline-block;
}

.scroll-text {
  font-size: 12px;
  color: #6c757d;
  font-weight: 500;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-5px);
  }
  60% {
    transform: translateY(-3px);
  }
}

@media (max-width: 480px) {
  .modal-content {
    margin: 10px;
    max-height: 70vh;
  }
  
  .modal-header {
    padding: 15px;
  }
  
  .modal-body {
    padding: 15px;
  }
  
  .detail-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .detail-value {
    text-align: right;
  }
}

/* Pagination styles */
.pagination-container {
  margin: 20px 0;
  padding: 20px;
  background: var(--background-color-secondary);
  border-radius: 8px;
  border: 1px solid var(--border-color);
}

.pagination-layout {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.pagination-page-info {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
}

.pagination-controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.pagination-record-info {
  font-size: 14px;
  color: #6c757d;
  font-weight: 500;
  text-align: right;
}

.pagination-btn {
  padding: 10px 20px;
  border: 1px solid var(--border-color);
  background: var(--background-color);
  color: var(--text-color-primary);
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  min-width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-btn:hover:not(:disabled) {
  background: var(--background-color-button);
  color: var(--text-color-primary);
  border-color: var(--background-color-button);
}

.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Mobile pagination styles */
@media (max-width: 768px) {
  .pagination-container {
    padding: 15px;
    margin: 15px 0;
  }
  
  .pagination-layout {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  
  .pagination-page-info,
  .pagination-record-info {
    text-align: center;
  }
  
  .pagination-controls {
    gap: 10px;
  }
  
  .pagination-btn {
    padding: 8px 16px;
    font-size: 13px;
    min-width: 70px;
    height: 36px;
  }
}

@media (max-width: 480px) {
  .pagination-container {
    padding: 10px;
  }
  
  .pagination-btn {
    padding: 6px 12px;
    font-size: 12px;
    min-width: 60px;
    height: 32px;
  }
  
  .pagination-page-info,
  .pagination-record-info {
    font-size: 12px;
  }
}
</style>
